// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:33:08.054Z
// Property: Icon at Hewitt (ID: 6767906449167042)
// Collections: 33 amenities, 6 floorplans (live), 53 photos, 55 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167042",
  "property_external_id": "580665",
  "property_zillow_url": "https://www.zillow.com/apartments/hewitt-tx/icon-at-hewitt/CghnqH/",
  "property_apartments_url": "https://www.apartments.com/icon-at-hewitt-hewitt-tx/s96eby7/",
  "property_google_business_url": "https://www.google.com/maps/place/Icon+at+Hewitt/data=!4m2!3m1!1s0x0:0xbdba5e8e42e17410?sa=X&ved=2ahUKEwjY1rLdhoOTAxUhF1kFHedFLiUQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "icon-at-hewitt",
  "property_name": "Icon at Hewitt",
  "property_website_url": "https://www.caseusa.com/apartments/tx/hewitt/icon-at-hewitt/",
  "property_domain": null,
  "property_address": "201 Ritchie Road",
  "property_full_address": "201 Ritchie Road, Hewitt, TX, 76643",
  "property_address_1": "201 Ritchie Road",
  "property_address_2": null,
  "property_address_city": "Hewitt",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "76643",
  "property_address_country": "US",
  "property_address_county": "McLennan County",
  "property_neighborhood_address": "Waco",
  "property_address_latitude": "31.4452",
  "property_address_longitude": "-97.2073",
  "property_email": "iconhewitt@caseusa.com",
  "property_phone": "(254) 632-5671",
  "property_call_tracking_phone": "866-204-8174",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Icon at Hewitt in Hewitt, TX, find spacious one-bedroom and two-bedroom layouts that blend modern comfort with pet-friendly amenities. Enjoy resort-style living with a stunning pool, relaxing sundecks, and a 24-hour fitness center. Your perfect home awaits—check our availability and schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to the Icon at Hewitt, your premier gated apartment community in the heart of Hewitt, TX. Offering contemporary living with thoughtfully designed floor plans, you can choose from spacious one-bedroom and two-bedroom apartments that perfectly suit your lifestyle. Enjoy the peace of mind that comes with our 24-hour emergency maintenance and reliable on-site management ready to assist you. \n\nImmerse yourself in a world of amenities at Icon at Hewitt that cater to both relaxation and recreation. You can unwind at our resort-style zero-entry pool with cabana or soak up the sun on our inviting sundeck. For pet owners, our onsite bark park and courtyards equipped with pet stations make it easy to care for your beloved pets. Plus, with garages available for rent and convenient package receiving, we ensure that your living experience is as hassle-free as possible.\n\nStay active in our 24-hour fitness center or catch up on work in our internet café, complete with gourmet coffee. Each apartment features modern conveniences such as central heat and air conditioning, fully equipped kitchens with a side-by-side refrigerator, microwave, and dishwasher, generous closet space, and private patios or balconies* to enjoy the outdoors. \n\nConveniently located near I-35, you’ll have easy access to all that Hewitt has to offer. Additionally, flexible payment options are available for your convenience. \n\nReady to elevate your living experience? Find your new home at Icon at Hewitt today—browse our availability or schedule a tour to visit our community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
  "property_featured_image_media": {
    "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
    "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
    "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
    "width": 3072,
    "height": 2460
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "264",
  "property_year_built": "2018",
  "property_year_renovated": null,
  "property_walk_score": "27",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.72727272727273",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "restricted breeds 80 pounds and under",
  "property_pet_policy_description": "Above applies to restricted breeds 80 pounds and under.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://iconathewittapartments.securecafe.com/onlineleasing/icon-at-hewitt/floorplans.aspx",
  "property_resident_portal_url": "https://iconathewittapartments.securecafe.com/residentservices/icon-at-hewitt/userlogin.aspx",
  "property_apply_now_url": "https://iconathewittapartments.securecafe.com/onlineleasing/icon-at-hewitt/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-d69f-76f2-accd-b90fc0c8f320.webp",
  "property_primary_logo_media": {
    "alt_text": "The Icon at Hewitt Urban Apartments logo",
    "public_id": "019cfb51-d69f-76f2-accd-b90fc0c8f320",
    "storage_key": "property/6767906449167042/019cfb51-d69f-76f2-accd-b90fc0c8f320.webp",
    "width": 1526,
    "height": 549
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb53-6b88-772a-b161-5ab6fac3c850.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The ICON AT HEWITT URBAN APARTMENTS logo",
    "public_id": "019cfb53-6b88-772a-b161-5ab6fac3c850",
    "storage_key": "property/6767906449167042/019cfb53-6b88-772a-b161-5ab6fac3c850.webp",
    "width": 640,
    "height": 230
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb53-74ea-7799-9185-4d1718675c35.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Icon at Hewitt logo",
    "public_id": "019cfb53-74ea-7799-9185-4d1718675c35",
    "storage_key": "property/6767906449167042/019cfb53-74ea-7799-9185-4d1718675c35.webp",
    "width": 640,
    "height": 230
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3d3d3f",
  "property_secondary_color": "#5d7274",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#eae0c8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1267",
  "property_sqft_min": "789",
  "property_sqft_max": "1267",
  "property_price_range": "1319 - 1839",
  "property_price_min": "1319",
  "property_price_max": "1839",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/photo/?fbid=693776012748046&set=ecnf.100063469603062",
  "property_instagram_url": "https://www.instagram.com/iconhewitt/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJh1833nKHT4YREHThQo5eur0",
  "property_youtube_url": "https://www.youtube.com/watch?v=TETbwGmkffk",
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Real+Estate&find_loc=Hewitt%2C+TX",
  "property_tiktok_url": "https://www.tiktok.com/@iconhewitt",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Icon at Hewitt",
  "property_home_romance_title": "Live Your Best Life in a Community You’ll Love",
  "property_home_amenities_blurb": "At Icon at Hewitt, modern living meets comfort in our spacious one and two-bedroom apartments. Nestled in a gated community, enjoy amenities like a resort-style pool, 24-hour fitness center, and relaxing courtyards. With pet-friendly features and easy access to I-35, your perfect home awaits in Hewitt, TX!",
  "property_home_floorplans_blurb": "At Icon at Hewitt, you'll find a captivating blend of style and comfort in our thoughtfully designed floor plans. Nestled in the heart of Hewitt, TX, our community invites you to picture life in a space that reflects your unique taste. Browse our available apartments and uncover your ideal home today!",
  "property_home_gallery_blurb": "Imagine life at Icon at Hewitt, where spacious one and two-bedroom floor plans meet resort-style amenities. Enjoy sun-soaked afternoons by the zero-entry pool, stroll through pet-friendly courtyards, and indulge in gourmet coffee at the internet cafe. Embrace modern living with designer finishes that make each day extraordinary!",
  "property_home_neighborhood_blurb": "At Icon at Hewitt, you’re not just finding a home; you’re stepping into a vibrant community. Nestled near Woodway Park and the scenic Carleen Bright Arboretum, enjoy easy access to lifestyle hubs like Richland Mall and Gold's Gym. Connect with nature and adventure without compromising on convenience!",
  "property_home_reviews_blurb": "At Icon at Hewitt, our residents rave about the vibrant community atmosphere, describing it as “a welcoming place where neighbors become friends.” Experience the warmth of our exceptional amenities and enjoy the convenience of Hewitt living. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Icon at Hewitt, vibrant living meets convenience. Nestled near lush parks, premier shopping spots like Richland Mall, and community gems such as the Hewitt Public Library, your new home offers endless opportunities. Explore local favorites like Urban Air Adventure Park and Cottonwood Creek Golf Course—there’s something for everyone!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Icon at Hewitt, your sanctuary awaits! Enjoy spacious one and two-bedroom layouts nestled in a gated community, complete with resort-style amenities. Unwind by the zero-entry pool, let your furry friends frolic in the bark park, or stay fit in our 24-hour gym. Your stylish retreat in Hewitt, TX, is calling!",
  "property_applynow_blurb": "Experience modern living at Icon at Hewitt, where stylish one- and two-bedroom apartments meet resort-style amenities. Relax by our zero-entry pool, enjoy fitness at any hour, or stroll through pet-friendly courtyards. With convenient access to I-35 and inviting interiors, your new home awaits. Lease online today and elevate your lifestyle!",
  "property_contactus_blurb": "At Icon at Hewitt, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Nestled in the charming town of Hewitt, TX, our community combines comfort and style. Have questions? Our leasing team is ready to assist you—reach out today and find your perfect home!",
  "property_faqs_blurb": "At Icon at Hewitt, we offer thoughtfully designed one-bedroom and two-bedroom floor plans to suit your needs. Nestled in the heart of Hewitt, TX, our vibrant community promises comfort and convenience. Have questions? Our FAQs page is your go-to resource for everything you need to know about living here!",
  "property_floorplans_blurb": "At Icon at Hewitt, each floor plan is crafted for modern living in the heart of Hewitt, TX. Whether you seek a spacious two-bedroom haven or an intimate one-bedroom retreat, our diverse options cater to your lifestyle. Browse our available apartment homes to find your ideal space today!",
  "property_gallery_blurb": "At Icon at Hewitt, vibrant living meets modern comfort in our pet-friendly gated community. Choose from spacious one and two-bedroom floor plans featuring stylish finishes and private balconies. Unwind by the resort-style pool or enjoy gourmet coffee in the internet café. Picture yourself here and elevate your lifestyle today!",
  "property_interactivemap_blurb": "At Icon at Hewitt, find your perfect sanctuary with spacious one and two-bedroom floor plans designed for modern living. Nestled in a gated community, enjoy amenities like a resort-style pool, an on-site bark park, and an inviting internet café. Dive into comfort and convenience—your next home awaits!",
  "property_pets_blurb": "Welcome to Icon at Hewitt, where modern living meets pet-friendly charm! Nestled in the heart of Hewitt, TX, our stylish apartments offer spacious layouts and vibrant community amenities. Perfect for furry companions, we accommodate pets under 80 pounds, ensuring every member of your family feels right at home.",
  "property_referafriend_blurb": "At Icon at Hewitt, we believe that great friendships create vibrant communities. With spacious one and two-bedroom floor plans designed for comfort and style, inviting friends to share your home is a no-brainer. Refer a friend today and enjoy the benefits of living in a welcoming neighborhood together!",
  "property_residentaccess_blurb": "Welcome to Icon at Hewitt, your Chic retreat in Hewitt, TX. Choose from spacious one and two-bedroom floor plans that fit your lifestyle. Easily manage your living experience by logging into our resident portal—effortlessly pay rent, schedule maintenance, and stay connected with your community. Your comfort awaits!",
  "property_reviews_blurb": "At Icon at Hewitt, residents rave about the welcoming atmosphere and modern amenities, with one stating, “Living here feels like home!” Our vibrant community fosters connections and comfort, making it the perfect place to create lasting memories. See what our residents have to say about living at our community!",
  "property_created_at": "1770683973055",
  "property_scheduletour_blurb": "At Icon at Hewitt, experience the perfect blend of comfort and style with our thoughtfully designed one and two-bedroom floor plans. Nestled in the heart of Hewitt, TX, our vibrant community is waiting for you. Schedule a tour today and find out why residents love calling us home!",
  "property_thankyou_blurb": "Thank you for reaching out to Icon at Hewitt, where spacious one- and two-bedroom floor plans await you in the heart of Hewitt, TX. Your journey to stylish and comfortable living starts here. Keep an eye on your inbox; our team will connect with you soon to answer your questions!",
  "property_virtualtours_blurb": "Experience the charm of Icon at Hewitt, where our thoughtfully designed floor plans offer the perfect blend of comfort and style. Choose from spacious one or two-bedroom apartments tailored to your lifestyle. Ready to envision your new home? Take a virtual tour of our community today!",
  "property_copyright": "2026 All Rights Reserved. Icon at Hewitt",
  "property_seo_title_home": "Icon at Hewitt |  Apartments in Hewitt, TX",
  "property_seo_description_home": "Experience upscale living at Icon at Hewitt! Enjoy spacious floor plans, resort-style amenities, and a pet-friendly community. Your modern oasis awaits!",
  "property_seo_title_floorplans": "Floor Plans | Hewitt, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Icon at Hewitt! Choose from stylish one- and two-bedroom floor plans tailored for comfort. Your perfect apartment awaits!",
  "property_seo_title_amenities": "Amenities | Hewitt, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience elevated living at Icon at Hewitt! Enjoy gated access, a resort-style pool, fitness center, and pet-friendly spaces. Find your perfect home today!",
  "property_seo_title_gallery": "Gallery | Apartments in Hewitt, TX",
  "property_seo_description_gallery": "Experience vibrant living at Icon at Hewitt! Enjoy our pet-friendly community with resort-style amenities and designer floor plans. Welcome home!",
  "property_seo_title_virtualtours": "Virtual Tours | Icon at Hewitt Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Icon at Hewitt! Take a virtual tour of our stylish one and two-bedroom apartments and see why this community is home.",
  "property_seo_title_interactivemap": "Interactive Map | Icon at Hewitt Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Icon at Hewitt! Enjoy spacious layouts, resort-style amenities, and a pet-friendly vibe. Explore our interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Hewitt, TX",
  "property_seo_description_neighborhood": "Uncover the charm of Hewitt at Icon at Hewitt. From vibrant local spots to serene parks, dive into the neighborhood's best kept secrets just outside your door!",
  "property_seo_title_contact": "Contact Us | Icon at Hewitt",
  "property_seo_description_contact": "Reach out to the leasing team at Icon at Hewitt! Whether you need info on our one or two-bedroom floor plans, we're here to help you find your perfect home.",
  "property_seo_title_faqs": "FAQs | Apartments in Hewitt, TX",
  "property_seo_description_faqs": "Explore FAQs about Icon at Hewitt, from pet-friendly amenities to floor plans, and get insights into your future home in Hewitt, TX!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Hewitt, TX",
  "property_seo_description_reviews": "Join the vibrant community at Icon at Hewitt! Browse resident reviews and see why our pet-friendly apartments with resort-style amenities are so loved!",
  "property_seo_title_applynow": "Apply Now | Apartments in Hewitt, TX",
  "property_seo_description_applynow": "Elevate your lifestyle at Icon at Hewitt! Choose from our stylish one or two-bedroom apartments with luxurious amenities. Apply online today for your new home!",
  "property_seo_title_residentaccess": "Resident Access | Icon at Hewitt",
  "property_seo_description_residentaccess": "Log in to Icon at Hewitt's resident portal for easy rent payments, maintenance requests, and community updates. Your hassle-free living starts here!",
  "property_seo_title_referafriend": "Refer A Friend | Icon at Hewitt",
  "property_seo_description_referafriend": "Refer a friend to Icon at Hewitt in TX! Great friends become great neighbors in a vibrant community. Share the joy of living here today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Icon at Hewitt",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Icon at Hewitt. Schedule your tour today and find your perfect home in the heart of Hewitt, TX! Your new adventure awaits!",
  "property_seo_title_privacy": "Privacy Policy | Icon at Hewitt",
  "property_seo_description_privacy": "Your privacy matters at Icon at Hewitt. Review our policy to see how we protect your personal information while you enjoy life in Hewitt, TX.",
  "property_seo_title_accessibility": "Website Accessibility | Icon at Hewitt",
  "property_seo_description_accessibility": "Experience inclusivity at Icon at Hewitt. Our commitment to accessibility ensures every resident feels at home in Hewitt, TX. Join us in embracing diversity!",
  "property_seo_title_sitemap": "Sitemap | Icon at Hewitt",
  "property_seo_description_sitemap": "Navigate your way to the perfect home at Icon at Hewitt! Check out our sitemap to uncover vibrant community features and amenities tailored for you.",
  "property_seo_title_thankyou": "Thank You | Icon at Hewitt",
  "property_seo_description_thankyou": "Thank you for reaching out to Icon at Hewitt! Our team will connect with you soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Hewitt, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865323441",
  "amenities": [
    {
      "id": "ec_46164846c4e23d39e97afcf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396678",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50fc1d154b1d381736b2bb93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396679",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7dd78d7ba0a466807337245",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396680",
      "title": "Courtyards with Pet Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_094745d4309eb9e3a19ff7f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396681",
      "title": "Garages Available*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c009e5e4cf5d4f218f7fcbe9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396682",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aaafcf86ba8a5993334aa101",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396683",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7473a2dd7323f85e68e64ce9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396684",
      "title": "Internet Cafe with Gourmet Coffee",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4edbb141b343c758b353d35e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396685",
      "title": "Resort-Style Zero-Entry Pool with Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5a300761b45b6ac762944c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396686",
      "title": "On-Site Management with Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcfba5262e0d07d936363db4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396687",
      "title": "Relaxing Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e20500fe6d2092bd1184ca9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396688",
      "title": "Onsite Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf1a1ad29f4251a35f9cfaf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396689",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1979b4b8d95abcf18ea74453",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396690",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51f8883d2b22b17693640cfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "128042569",
      "title": "Astound Broadband by Grande",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7aebc8e6c9def54f4a875d5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127396691",
      "title": "Close to I-35",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ea26664c456f243447e30f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398168",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38f7b0957515ecbb21b0bfd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398169",
      "title": "Designer Colors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_518507ed5e8441150e47bf14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398170",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb33cb2cbe2d4f6f8647322f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398171",
      "title": "Stove",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44854281b7284de4affab53c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398172",
      "title": "Central Heat & Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b78521856d2b8f117f2231d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398173",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df6097a5c2f7585b804eba1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398174",
      "title": "Ceiling Fan in Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a3eb3bc007551b73eebe54e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398175",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ec8a2a389f5e5212fa1d680",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398176",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57ea9f7e5e18d4766e1013e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398177",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19572dcf1ea56a5d340fd5dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398178",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_626a72d2b4dcaa101498139a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398179",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88c9bf22c256e70385975d77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398180",
      "title": "Side-by-Side Refrigerator with Ice Maker and Filtered Water",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40472ac1765f48a5847af8a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398181",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82146a83738ceca029dacc71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398182",
      "title": "Handicapped Accessible*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7912d9bffbb850339e91c8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398183",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_844f634513e00a9c48212c0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398184",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7232717593b86092409311d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "yardi",
      "external_id": "127398185",
      "title": "Loft-Style Living*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_40c7b42b-512a-4fb3-a0d8-daf36a6dd38f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-a256-76d1-b2e0-d69a0bbec6b9.webp",
      "image_media": {
        "alt_text": "Brick entrance canopy at an apartment community with landscaped walkways and a sign reading 'The Icon'.",
        "public_id": "019d20b9-a256-76d1-b2e0-d69a0bbec6b9",
        "storage_key": "property/6767906449167042/019d20b9-a256-76d1-b2e0-d69a0bbec6b9.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Community",
      "description": "Exterior view of The Icon apartment community entrance with brick columns, landscaping, and welcoming signage.",
      "link": "",
      "alt_text": "Brick entrance canopy at an apartment community with landscaped walkways and a sign reading 'The Icon'.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp"
    },
    {
      "id": "custom_cfde21be-2439-45c1-bd2e-9c640cf365c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-a1b3-728a-8994-282d856d12f3.webp",
      "image_media": {
        "alt_text": "Brick entrance sign for The Icon at Hewitt Urban Apartments with landscaping and blue sky.",
        "public_id": "019d20b9-a1b3-728a-8994-282d856d12f3",
        "storage_key": "property/6767906449167042/019d20b9-a1b3-728a-8994-282d856d12f3.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Exterior sign at The Icon at Hewitt Urban Apartments with a brick monument and manicured landscaping.",
      "link": "",
      "alt_text": "Brick entrance sign for The Icon at Hewitt Urban Apartments with landscaping and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-e7d4-7758-86c3-13a1f6a4da23.webp"
    },
    {
      "id": "custom_383898db-8b2f-43a0-949a-802770fafc66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-a1a5-76af-a168-e8a835bae16a.webp",
      "image_media": {
        "alt_text": "Fenced grassy courtyard with playground between apartment buildings.",
        "public_id": "019d20b9-a1a5-76af-a168-e8a835bae16a",
        "storage_key": "property/6767906449167042/019d20b9-a1a5-76af-a168-e8a835bae16a.webp",
        "width": 1920,
        "height": 1201
      },
      "title": "Community",
      "description": "Photo of a residential community courtyard with a playground and multi-story apartment buildings.",
      "link": "",
      "alt_text": "Fenced grassy courtyard with playground between apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-d6b7-7078-b8d7-7e64399194d1.webp"
    },
    {
      "id": "custom_8dedfad7-fb12-4bd4-8cbd-a3c026795946",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-a264-7349-b4ff-bb67253096c2.webp",
      "image_media": {
        "alt_text": "Exterior view of a pet-friendly community park with a fenced playground and apartment buildings in the background.",
        "public_id": "019d20b9-a264-7349-b4ff-bb67253096c2",
        "storage_key": "property/6767906449167042/019d20b9-a264-7349-b4ff-bb67253096c2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior of a pet-friendly apartment community with a central lawn, fenced play area, and residential buildings.",
      "link": "",
      "alt_text": "Exterior view of a pet-friendly community park with a fenced playground and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-ebc1-77b2-8a38-19ec65c050c7.webp"
    },
    {
      "id": "custom_adbb05ae-e78a-4f03-aa4a-a85bab8105aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-ab10-752b-b591-1391c80e2148.webp",
      "image_media": {
        "alt_text": "Exterior view of a fenced pet park within an apartment community, with buildings in the background.",
        "public_id": "019d20b9-ab10-752b-b591-1391c80e2148",
        "storage_key": "property/6767906449167042/019d20b9-ab10-752b-b591-1391c80e2148.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior view of a pet-friendly apartment community with a fenced dog park and green lawn.",
      "link": "",
      "alt_text": "Exterior view of a fenced pet park within an apartment community, with buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-af44-72bb-ae33-06cfbb1ec2e3.webp"
    },
    {
      "id": "custom_c2317f52-c859-4dc5-8a9c-03fd0332a567",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-ad00-77de-9568-e02dc7384943.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-building apartment community with green lawns and a picnic area.",
        "public_id": "019d20b9-ad00-77de-9568-e02dc7384943",
        "storage_key": "property/6767906449167042/019d20b9-ad00-77de-9568-e02dc7384943.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community with green lawns, walkways, and communal outdoor spaces.",
      "link": "",
      "alt_text": "Exterior view of a multi-building apartment community with green lawns and a picnic area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-d698-771c-910b-9b13fc4de255.webp"
    },
    {
      "id": "custom_597a8c74-3541-41c2-a20d-40cc6cc6787e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-ae05-716c-874c-72b4c92607d6.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick multifamily building with glass doors, windows, and a landscaped entrance.",
        "public_id": "019d20b9-ae05-716c-874c-72b4c92607d6",
        "storage_key": "property/6767906449167042/019d20b9-ae05-716c-874c-72b4c92607d6.webp",
        "width": 1920,
        "height": 1201
      },
      "title": "Community",
      "description": "Exterior view of a modern multifamily community with brick facade, landscaping, and a welcoming entrance.",
      "link": "",
      "alt_text": "Exterior view of a brick multifamily building with glass doors, windows, and a landscaped entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-d698-771c-910b-905cf9157160.webp"
    },
    {
      "id": "custom_c438df5b-3e46-45cd-baae-c5a8bb97adc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-baf7-719b-ad60-7fd318ad28b2.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment complex with balconies and a green lawn.",
        "public_id": "019d20b9-baf7-719b-ad60-7fd318ad28b2",
        "storage_key": "property/6767906449167042/019d20b9-baf7-719b-ad60-7fd318ad28b2.webp",
        "width": 1920,
        "height": 1201
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community with manicured lawns, walkways, and balcony units.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment complex with balconies and a green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-d873-772b-af0e-395ffd221d5f.webp"
    },
    {
      "id": "custom_6a161f25-6da9-4be1-992e-876f3137b861",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-c40b-71ff-afc2-69b4db829b68.webp",
      "image_media": {
        "alt_text": "Balcony with seating overlooks a lush courtyard and surrounding apartment buildings.",
        "public_id": "019d20b9-c40b-71ff-afc2-69b4db829b68",
        "storage_key": "property/6767906449167042/019d20b9-c40b-71ff-afc2-69b4db829b68.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Community",
      "description": "View from a balcony showing a lush courtyard, shaded walkways, and surrounding apartment buildings - highlighting the property's welcoming community.",
      "link": "",
      "alt_text": "Balcony with seating overlooks a lush courtyard and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-8770-736f-a406-266fb657f65c.webp"
    },
    {
      "id": "custom_a05280a1-e97d-42ef-9721-f5adbfa06c9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-d361-71ad-92fd-2c6ba8d2a4d7.webp",
      "image_media": {
        "alt_text": "Outdoor community courtyard with stone patio, grills, and seating near apartment buildings.",
        "public_id": "019d20b9-d361-71ad-92fd-2c6ba8d2a4d7",
        "storage_key": "property/6767906449167042/019d20b9-d361-71ad-92fd-2c6ba8d2a4d7.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Shared outdoor courtyard at a multifamily community with a stone patio, grills, and benches near residential buildings.",
      "link": "",
      "alt_text": "Outdoor community courtyard with stone patio, grills, and seating near apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-d698-771c-910b-97b7f8bbf019.webp"
    },
    {
      "id": "custom_1156f723-5abd-40f0-b8c6-b2098f1de72c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-d72b-74d9-a2a1-18d15f451dc3.webp",
      "image_media": {
        "alt_text": "Outdoor communal grilling area with stone fireplace, benches, and tables, with apartment buildings in the background.",
        "public_id": "019d20b9-d72b-74d9-a2a1-18d15f451dc3",
        "storage_key": "property/6767906449167042/019d20b9-d72b-74d9-a2a1-18d15f451dc3.webp",
        "width": 1920,
        "height": 1202
      },
      "title": "Community",
      "description": "Shared outdoor grilling area with a stone fireplace and picnic tables, set among landscaped courtyards and apartment buildings.",
      "link": "",
      "alt_text": "Outdoor communal grilling area with stone fireplace, benches, and tables, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-d85d-777a-99fd-86d0ddb127fd.webp"
    },
    {
      "id": "custom_35857bd7-7296-4508-8f8f-83070d4babb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-dd60-7383-be40-c36ac2f296ba.webp",
      "image_media": {
        "alt_text": "Covered brick patio with red-cushioned lounge seating and a wall-mounted TV.",
        "public_id": "019d20b9-dd60-7383-be40-c36ac2f296ba",
        "storage_key": "property/6767906449167042/019d20b9-dd60-7383-be40-c36ac2f296ba.webp",
        "width": 1920,
        "height": 1201
      },
      "title": "Community",
      "description": "Amenities lounge at the community clubhouse featuring brick arches, a TV, and comfortable red seating for residents.",
      "link": "",
      "alt_text": "Covered brick patio with red-cushioned lounge seating and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-d6b7-7078-b8d7-75f56a34ac36.webp"
    },
    {
      "id": "custom_1f5d72d8-f869-4e52-a623-12e4d86e1361",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-e173-746d-8b10-faf4d6601636.webp",
      "image_media": {
        "alt_text": "Outdoor community pool with lounge chairs, umbrellas, and a brick poolside cabana, surrounded by apartment buildings.",
        "public_id": "019d20b9-e173-746d-8b10-faf4d6601636",
        "storage_key": "property/6767906449167042/019d20b9-e173-746d-8b10-faf4d6601636.webp",
        "width": 1920,
        "height": 1201
      },
      "title": "Community",
      "description": "A resort-style pool area at a multifamily community featuring chaise lounges, umbrellas, and a brick cabana near residential buildings.",
      "link": "",
      "alt_text": "Outdoor community pool with lounge chairs, umbrellas, and a brick poolside cabana, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-d6b7-7078-b8d7-7895c6d1aba2.webp"
    },
    {
      "id": "custom_5cd27791-5d58-4553-b3c3-30e9e9478d3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-e4d2-7777-bb5a-1f352e1b93de.webp",
      "image_media": {
        "alt_text": "Outdoor community pool area with a brick pool house and lounge chairs.",
        "public_id": "019d20b9-e4d2-7777-bb5a-1f352e1b93de",
        "storage_key": "property/6767906449167042/019d20b9-e4d2-7777-bb5a-1f352e1b93de.webp",
        "width": 1920,
        "height": 1201
      },
      "title": "Community",
      "description": "Bright outdoor pool area at a multifamily community featuring a brick pool house, fencing, and poolside seating.",
      "link": "",
      "alt_text": "Outdoor community pool area with a brick pool house and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-e221-7748-874a-0bbc588ebfe3.webp"
    },
    {
      "id": "custom_fe150cb4-5611-4c43-9783-53432ee861bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-e522-747b-a3a5-713f92f88ff5.webp",
      "image_media": {
        "alt_text": "Outdoor pool at a multifamily property with red lounge chairs and a brick cabana.",
        "public_id": "019d20b9-e522-747b-a3a5-713f92f88ff5",
        "storage_key": "property/6767906449167042/019d20b9-e522-747b-a3a5-713f92f88ff5.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Relax by the large outdoor pool at our apartment community, featuring a brick cabana and plenty of lounge seating.",
      "link": "",
      "alt_text": "Outdoor pool at a multifamily property with red lounge chairs and a brick cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-e95d-746d-ad93-ea2d14cddad1.webp"
    },
    {
      "id": "custom_ad71a81c-c3fc-417e-856f-8d266d676d25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-eb10-707d-8725-aadd27adba9e.webp",
      "image_media": {
        "alt_text": "Row of black metal mailboxes along a covered walkway of an apartment building.",
        "public_id": "019d20b9-eb10-707d-8725-aadd27adba9e",
        "storage_key": "property/6767906449167042/019d20b9-eb10-707d-8725-aadd27adba9e.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior view of a multifamily community showing a long row of black mailbox units under a covered entry.",
      "link": "",
      "alt_text": "Row of black metal mailboxes along a covered walkway of an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-8822-716e-b589-99e89f1a17e6.webp"
    },
    {
      "id": "custom_f89092d1-ff4f-47b4-88d3-5a68cda18688",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-eec5-75ff-b3cc-fb4c8aaae044.webp",
      "image_media": {
        "alt_text": "Common area with a long workstation, computers, and a large wall-mounted screen.",
        "public_id": "019d20b9-eec5-75ff-b3cc-fb4c8aaae044",
        "storage_key": "property/6767906449167042/019d20b9-eec5-75ff-b3cc-fb4c8aaae044.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Community",
      "description": "Modern community lounge with computer workstations and a large wall-mounted TV for resident use.",
      "link": "",
      "alt_text": "Common area with a long workstation, computers, and a large wall-mounted screen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-74ac-72c9-9ace-fb4ae7d52454.webp"
    },
    {
      "id": "custom_e2c77601-4e45-4b99-80c5-773f35507207",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-f038-727b-9732-92bc77f5960b.webp",
      "image_media": {
        "alt_text": "Luxurious community lounge with a stone fireplace, high wood-beam ceiling, and modern seating.",
        "public_id": "019d20b9-f038-727b-9732-92bc77f5960b",
        "storage_key": "property/6767906449167042/019d20b9-f038-727b-9732-92bc77f5960b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Spacious amenity lounge with a stone fireplace, exposed-beam ceiling, and comfortable seating for residents.",
      "link": "",
      "alt_text": "Luxurious community lounge with a stone fireplace, high wood-beam ceiling, and modern seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-e35e-725c-b5b5-0e1efd6cb905.webp"
    },
    {
      "id": "custom_1f33c24e-e1da-4962-a70c-35c2be65712a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-efe7-72ac-ad92-175c67331e5d.webp",
      "image_media": {
        "alt_text": "Spacious lobby with a stone fireplace, contemporary seating, and a wall-mounted TV.",
        "public_id": "019d20b9-efe7-72ac-ad92-175c67331e5d",
        "storage_key": "property/6767906449167042/019d20b9-efe7-72ac-ad92-175c67331e5d.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Community",
      "description": "A stylish communal living area with modern furnishings, a stone fireplace, and ample seating for residents.",
      "link": "",
      "alt_text": "Spacious lobby with a stone fireplace, contemporary seating, and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-732b-7348-93cf-5bca681e61b5.webp"
    },
    {
      "id": "custom_3577e268-e96f-47b2-b0ad-5aee1d51cd3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-f8c9-73dc-befe-5ebb342ddb09.webp",
      "image_media": {
        "alt_text": "Indoor community gym with treadmills, weight rack, and free weights.",
        "public_id": "019d20b9-f8c9-73dc-befe-5ebb342ddb09",
        "storage_key": "property/6767906449167042/019d20b9-f8c9-73dc-befe-5ebb342ddb09.webp",
        "width": 1920,
        "height": 1201
      },
      "title": "Community",
      "description": "Modern on-site fitness center for residents featuring cardio machines, free weights, and versatile training equipment.",
      "link": "",
      "alt_text": "Indoor community gym with treadmills, weight rack, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-ebc2-75da-b2d0-7ade206845ec.webp"
    },
    {
      "id": "custom_6fb206da-4026-43fb-b251-ef25c2e72c52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-f959-75ba-a6f0-5d95cf0fddef.webp",
      "image_media": {
        "alt_text": "Well-equipped communal fitness center with treadmills, elliptical, and weight machines.",
        "public_id": "019d20b9-f959-75ba-a6f0-5d95cf0fddef",
        "storage_key": "property/6767906449167042/019d20b9-f959-75ba-a6f0-5d95cf0fddef.webp",
        "width": 1920,
        "height": 1201
      },
      "title": "Community",
      "description": "On-site fitness center offering cardio and strength equipment for residents.",
      "link": "",
      "alt_text": "Well-equipped communal fitness center with treadmills, elliptical, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-d872-717e-a616-6f6cca4aab96.webp"
    },
    {
      "id": "custom_5e96d0e4-f89a-4f63-86dc-360968512d54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-fba2-746e-827e-c2dd6404a876.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a couch, coffee table, TV stand, large windows, and a side lamp.",
        "public_id": "019d20b9-fba2-746e-827e-c2dd6404a876",
        "storage_key": "property/6767906449167042/019d20b9-fba2-746e-827e-c2dd6404a876.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy living room in a modern apartment featuring a sectional sofa, coffee table, TV, and large windows that flood the space with natural light.",
      "link": "",
      "alt_text": "Living room in an apartment with a couch, coffee table, TV stand, large windows, and a side lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-731a-70ce-ba84-e6e0def07b99.webp"
    },
    {
      "id": "custom_d36f2abe-7829-480e-8768-e24674d98ab1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20b9-fd20-748c-a19b-9510d545a4c8.webp",
      "image_media": {
        "alt_text": "Cozy apartment living room with sofa, armchairs, coffee tables, dining area, and large windows.",
        "public_id": "019d20b9-fd20-748c-a19b-9510d545a4c8",
        "storage_key": "property/6767906449167042/019d20b9-fd20-748c-a19b-9510d545a4c8.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright, neutrally decorated apartment living room with a comfortable seating area, dining nook, and large windows.",
      "link": "",
      "alt_text": "Cozy apartment living room with sofa, armchairs, coffee tables, dining area, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-76ea-76ed-9fd9-8fd0ea091c0f.webp"
    },
    {
      "id": "custom_70ee97bc-9082-458e-8c09-3f9474ce5b43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-022f-732d-ba96-4b8013ddab93.webp",
      "image_media": {
        "alt_text": "Bathroom with a single-sink marble vanity, towels, toilet, a wall cabinet, and a geometric-pattern shower curtain.",
        "public_id": "019d20ba-022f-732d-ba96-4b8013ddab93",
        "storage_key": "property/6767906449167042/019d20ba-022f-732d-ba96-4b8013ddab93.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a marble countertop, dark cabinetry, decorative wall art, and a geometric shower curtain.",
      "link": "",
      "alt_text": "Bathroom with a single-sink marble vanity, towels, toilet, a wall cabinet, and a geometric-pattern shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-7715-72bb-a426-dca800006409.webp"
    },
    {
      "id": "custom_0ca82bf6-ae5b-437b-8d30-2cd6096d505a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-0480-73c4-a76d-f85dd2c951f2.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with dark wood cabinets, stainless steel refrigerator, and tiled backsplash.",
        "public_id": "019d20ba-0480-73c4-a76d-f85dd2c951f2",
        "storage_key": "property/6767906449167042/019d20ba-0480-73c4-a76d-f85dd2c951f2.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Sleek kitchen in a contemporary apartment with stainless steel appliances, dark cabinetry, and a textured tile backsplash.",
      "link": "",
      "alt_text": "Modern apartment kitchen with dark wood cabinets, stainless steel refrigerator, and tiled backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-7791-746d-b28a-e752f1dca8a2.webp"
    },
    {
      "id": "custom_7ab0002a-ff43-4e4c-8a14-3b1305a0c074",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-05b7-762e-86cb-15d721e595af.webp",
      "image_media": {
        "alt_text": "Bedroom with a gray tufted headboard bed, ceiling fan, dresser, window with blinds, and potted plants.",
        "public_id": "019d20ba-05b7-762e-86cb-15d721e595af",
        "storage_key": "property/6767906449167042/019d20ba-05b7-762e-86cb-15d721e595af.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with warm bedding, a tufted headboard, ceiling fan, dresser, and greenery.",
      "link": "",
      "alt_text": "Bedroom with a gray tufted headboard bed, ceiling fan, dresser, window with blinds, and potted plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-836c-7014-bb6e-0edc39c28761.webp"
    },
    {
      "id": "custom_4876f859-b3ca-4671-a459-c8f817c568e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-06c0-77ab-bd5b-5bb37ffed76d.webp",
      "image_media": {
        "alt_text": "Bathroom with marble countertop, dual sink vanity, toilet, tub/shower, green towels, and framed art.",
        "public_id": "019d20ba-06c0-77ab-bd5b-5bb37ffed76d",
        "storage_key": "property/6767906449167042/019d20ba-06c0-77ab-bd5b-5bb37ffed76d.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a marble countertop double sink, dark wood cabinetry, white tile shower, and green accents.",
      "link": "",
      "alt_text": "Bathroom with marble countertop, dual sink vanity, toilet, tub/shower, green towels, and framed art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-854b-71b1-96d1-b14f99e467e9.webp"
    },
    {
      "id": "custom_353019aa-a977-4851-8049-59b4a0da6615",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-0b5a-7270-a3f1-20f4e61a6297.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a queen bed, gray headboard, dresser, nightstand, ceiling fan, and two windows with sheer curtains.",
        "public_id": "019d20ba-0b5a-7270-a3f1-20f4e61a6297",
        "storage_key": "property/6767906449167042/019d20ba-0b5a-7270-a3f1-20f4e61a6297.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright bedroom in a multifamily unit with a queen bed, dresser, nightstand, and ceiling fan.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a queen bed, gray headboard, dresser, nightstand, ceiling fan, and two windows with sheer curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-87ca-71bd-8286-3a951b308694.webp"
    },
    {
      "id": "custom_616664c2-cd36-496f-a03e-3fed453c4256",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-0e1a-74cd-9e95-ed455cdfc84e.webp",
      "image_media": {
        "alt_text": "Spacious apartment living room with a sofa, chairs, coffee table, and large windows.",
        "public_id": "019d20ba-0e1a-74cd-9e95-ed455cdfc84e",
        "storage_key": "property/6767906449167042/019d20ba-0e1a-74cd-9e95-ed455cdfc84e.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright, modern living area in a residential apartment with ample seating and natural light.",
      "link": "",
      "alt_text": "Spacious apartment living room with a sofa, chairs, coffee table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-881c-70a6-bbf8-a073fabac199.webp"
    },
    {
      "id": "custom_325ea712-c3e6-4434-b405-f278b785e98f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-17a9-769e-839b-0b59e82aef21.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with a tub/shower, toilet, and marble countertop vanity.",
        "public_id": "019d20ba-17a9-769e-839b-0b59e82aef21",
        "storage_key": "property/6767906449167042/019d20ba-17a9-769e-839b-0b59e82aef21.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a tub/shower, marble vanity, and neutral decor.",
      "link": "",
      "alt_text": "Bathroom in an apartment with a tub/shower, toilet, and marble countertop vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-8dbd-723f-a300-3f05ef75a28e.webp"
    },
    {
      "id": "custom_53db5340-53bd-4da8-a112-f77c8b30b45f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-2147-73b7-9f86-a606bf2a2214.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sink, marble countertop, and a mirror in an apartment.",
        "public_id": "019d20ba-2147-73b7-9f86-a606bf2a2214",
        "storage_key": "property/6767906449167042/019d20ba-2147-73b7-9f86-a606bf2a2214.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a double-sink vanity, marble countertop, and decorative plants in a cozy nook.",
      "link": "",
      "alt_text": "Bathroom vanity with double sink, marble countertop, and a mirror in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-8ec6-72de-8bc3-ad3840ad0c1c.webp"
    },
    {
      "id": "custom_bde8e2f3-36ed-4f87-8688-39ff0409131c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-2b6c-711f-a0c4-e608f45aee1b.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with marble countertop, single sink, toilet, and tub/shower with a patterned curtain.",
        "public_id": "019d20ba-2b6c-711f-a0c4-e608f45aee1b",
        "storage_key": "property/6767906449167042/019d20ba-2b6c-711f-a0c4-e608f45aee1b.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a marble vanity, dark wood cabinets, and a white tile shower.",
      "link": "",
      "alt_text": "Bathroom in an apartment with marble countertop, single sink, toilet, and tub/shower with a patterned curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-9dc6-734e-aa5e-977ea129a671.webp"
    },
    {
      "id": "custom_e5f987a9-9ff1-4744-ab06-e8302cc68416",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-2bbf-7035-9192-8415b07dd694.webp",
      "image_media": {
        "alt_text": "U-shaped kitchen with dark wood cabinets, stainless steel stove and microwave, and marble countertops.",
        "public_id": "019d20ba-2bbf-7035-9192-8415b07dd694",
        "storage_key": "property/6767906449167042/019d20ba-2bbf-7035-9192-8415b07dd694.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern kitchen in a multifamily unit with dark wood cabinets, marble countertops, and stainless steel appliances.",
      "link": "",
      "alt_text": "U-shaped kitchen with dark wood cabinets, stainless steel stove and microwave, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-9e6e-76a9-ad35-8b3ea46735cc.webp"
    },
    {
      "id": "custom_79661ca5-ad77-44a1-afee-e1a8ed37e906",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-306a-754d-9175-54b7e66f93af.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen with dark cabinets, stainless steel appliances, and a living area.",
        "public_id": "019d20ba-306a-754d-9175-54b7e66f93af",
        "storage_key": "property/6767906449167042/019d20ba-306a-754d-9175-54b7e66f93af.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Open-concept kitchen and living area in a modern apartment featuring dark cabinetry and stainless steel appliances.",
      "link": "",
      "alt_text": "Open-concept kitchen with dark cabinets, stainless steel appliances, and a living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-9ec6-705b-8f7b-f505568c9a6c.webp"
    },
    {
      "id": "custom_12ec7247-c932-46b1-80a0-8d2eb6bf0733",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-3459-740a-8c4c-6460508264df.webp",
      "image_media": {
        "alt_text": "Round dining table with four gray chairs in a compact living-dining area.",
        "public_id": "019d20ba-3459-740a-8c4c-6460508264df",
        "storage_key": "property/6767906449167042/019d20ba-3459-740a-8c4c-6460508264df.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy dining space in a modern apartment with a round table, four chairs, and decorative wall art.",
      "link": "",
      "alt_text": "Round dining table with four gray chairs in a compact living-dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-a34d-710d-a992-804b795a3cef.webp"
    },
    {
      "id": "custom_49864cbc-021e-430d-9f2e-9a859280180d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-35fd-720c-aeea-9242662c651a.webp",
      "image_media": {
        "alt_text": "Open-plan living room with beige sofa, coffee table, TV, and kitchen counter with bar stools.",
        "public_id": "019d20ba-35fd-720c-aeea-9242662c651a",
        "storage_key": "property/6767906449167042/019d20ba-35fd-720c-aeea-9242662c651a.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright, open-plan apartment living area with neutral decor, a TV, and a modern kitchen with a breakfast bar.",
      "link": "",
      "alt_text": "Open-plan living room with beige sofa, coffee table, TV, and kitchen counter with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-a373-768a-9acd-12d10332407c.webp"
    },
    {
      "id": "custom_2e5dc2ee-5844-4756-9278-76344662e337",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-3a86-721f-a526-42afb971d4af.webp",
      "image_media": {
        "alt_text": "Bedroom with a king bed, tufted headboard, two nightstands, and a ceiling fan.",
        "public_id": "019d20ba-3a86-721f-a526-42afb971d4af",
        "storage_key": "property/6767906449167042/019d20ba-3a86-721f-a526-42afb971d4af.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment bedroom with matching nightstands, warm bedding, and neutral decor.",
      "link": "",
      "alt_text": "Bedroom with a king bed, tufted headboard, two nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-a31e-7405-a548-1d130664ded4.webp"
    },
    {
      "id": "custom_b59ad5f6-5706-4fc5-b8c6-56c3dac5b1a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-3d36-772c-aa42-c02734ab0ee4.webp",
      "image_media": {
        "alt_text": "Bathroom in a modern apartment featuring dark wood vanity, marble countertop, and a green shower curtain.",
        "public_id": "019d20ba-3d36-772c-aa42-c02734ab0ee4",
        "storage_key": "property/6767906449167042/019d20ba-3d36-772c-aa42-c02734ab0ee4.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Interior image of an apartment bathroom showing a dark wood vanity with marble countertop, mirror, toilet, and a green grid-pattern shower curtain.",
      "link": "",
      "alt_text": "Bathroom in a modern apartment featuring dark wood vanity, marble countertop, and a green shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-a70f-75e0-9e24-d7b4eb6ba7e1.webp"
    },
    {
      "id": "custom_e66547e9-3369-4999-a5ca-c39f0e646318",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-42f3-73dc-902f-a6dda65d4186.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a wooden bed frame, nightstand, lamp, ceiling fan, and window with teal curtains.",
        "public_id": "019d20ba-42f3-73dc-902f-a6dda65d4186",
        "storage_key": "property/6767906449167042/019d20ba-42f3-73dc-902f-a6dda65d4186.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy bedroom in a stylish apartment with wood furniture, soft décor, and natural light from a window.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a wooden bed frame, nightstand, lamp, ceiling fan, and window with teal curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-a70f-75e0-9e24-d8a4ae6644fc.webp"
    },
    {
      "id": "custom_e8d0d766-50c0-42e8-8628-c918dff1761f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-4971-73ac-a0b7-7e93b275d87d.webp",
      "image_media": {
        "alt_text": "Dining area in a neutral apartment with a round table, black chairs, wall art, and a potted plant.",
        "public_id": "019d20ba-4971-73ac-a0b7-7e93b275d87d",
        "storage_key": "property/6767906449167042/019d20ba-4971-73ac-a0b7-7e93b275d87d.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Interior view of a contemporary apartment dining nook with a round table, black chairs, wall art, and a tall plant by the glass doors.",
      "link": "",
      "alt_text": "Dining area in a neutral apartment with a round table, black chairs, wall art, and a potted plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-a738-75c0-b989-968a11d31491.webp"
    },
    {
      "id": "custom_a25761f6-a957-4a39-9a1f-e7f2aad1a1b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-4ce3-707f-b9a3-4736c9a5cdad.webp",
      "image_media": {
        "alt_text": "Open-concept living area with dining table, kitchen island, dark cabinets, and stainless appliances.",
        "public_id": "019d20ba-4ce3-707f-b9a3-4736c9a5cdad",
        "storage_key": "property/6767906449167042/019d20ba-4ce3-707f-b9a3-4736c9a5cdad.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright, spacious apartment living area featuring a dining nook and modern kitchen in an open layout.",
      "link": "",
      "alt_text": "Open-concept living area with dining table, kitchen island, dark cabinets, and stainless appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-aa8b-76eb-836e-1266512c3b14.webp"
    },
    {
      "id": "custom_6fae371d-8cf5-4d15-95b3-93dc6a129f51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-4cc2-7068-be85-5cd560c4d955.webp",
      "image_media": {
        "alt_text": "U-shaped kitchen with dark wood cabinets, marble countertops, and stainless steel appliances.",
        "public_id": "019d20ba-4cc2-7068-be85-5cd560c4d955",
        "storage_key": "property/6767906449167042/019d20ba-4cc2-7068-be85-5cd560c4d955.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with dark cabinetry, marble-style countertops, and stainless steel appliances.",
      "link": "",
      "alt_text": "U-shaped kitchen with dark wood cabinets, marble countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-af6d-734a-aaf3-808564a3ad58.webp"
    },
    {
      "id": "custom_a024cf47-d178-45ba-8756-5fee808cb030",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-5293-77fa-962c-ac29b86a5d65.webp",
      "image_media": {
        "alt_text": "Dining nook with a round wooden table, four upholstered chairs, and large windows with blinds.",
        "public_id": "019d20ba-5293-77fa-962c-ac29b86a5d65",
        "storage_key": "property/6767906449167042/019d20ba-5293-77fa-962c-ac29b86a5d65.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright dining nook in a modern apartment with a round table, four chairs, and abundant natural light from large windows.",
      "link": "",
      "alt_text": "Dining nook with a round wooden table, four upholstered chairs, and large windows with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-af60-71fa-9685-6689cff17317.webp"
    },
    {
      "id": "custom_f26deb19-f251-4a08-816f-86821ea74f1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-5548-7329-bb6e-c1ea5a9a3600.webp",
      "image_media": {
        "alt_text": "Cozy living room with a dark sofa, two round coffee tables, a TV on a wooden stand, and a bar counter.",
        "public_id": "019d20ba-5548-7329-bb6e-c1ea5a9a3600",
        "storage_key": "property/6767906449167042/019d20ba-5548-7329-bb6e-c1ea5a9a3600.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright open living space in a modern apartment with a sofa, TV, coffee tables, plants, and a bar-height kitchen counter.",
      "link": "",
      "alt_text": "Cozy living room with a dark sofa, two round coffee tables, a TV on a wooden stand, and a bar counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-b380-717e-93fd-a5749c32b0e0.webp"
    },
    {
      "id": "custom_46e58aef-e10c-4580-90d2-9d0f2ca83373",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-58db-76d5-a79d-92d6a8c0478a.webp",
      "image_media": {
        "alt_text": "Bedroom with a wooden headboard, ceiling fan, two nightstands, and doors to a closet and bathroom.",
        "public_id": "019d20ba-58db-76d5-a79d-92d6a8c0478a",
        "storage_key": "property/6767906449167042/019d20ba-58db-76d5-a79d-92d6a8c0478a.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious apartment bedroom with a large wooden bed, neutral decor, and easy access to a closet and ensuite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a wooden headboard, ceiling fan, two nightstands, and doors to a closet and bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-b8a0-77fa-9056-7b090dcd5153.webp"
    },
    {
      "id": "custom_12c57e51-0e9c-4968-9cfa-484ae7686383",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-5b16-778b-a66d-98b429ea53df.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white wire shelves and storage baskets.",
        "public_id": "019d20ba-5b16-778b-a66d-98b429ea53df",
        "storage_key": "property/6767906449167042/019d20ba-5b16-778b-a66d-98b429ea53df.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Interior view of an apartment closet with wire shelving and woven baskets for organizing clothing and accessories.",
      "link": "",
      "alt_text": "Walk-in closet with white wire shelves and storage baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-76cd-750d-a34d-93f848d3978d.webp"
    },
    {
      "id": "custom_bd469c50-c39a-4094-afeb-91cd66e4a72d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-5f4f-7297-b63c-8ddf9b2b51ba.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelves on beige walls.",
        "public_id": "019d20ba-5f4f-7297-b63c-8ddf9b2b51ba",
        "storage_key": "property/6767906449167042/019d20ba-5f4f-7297-b63c-8ddf9b2b51ba.webp",
        "width": 1280,
        "height": 800
      },
      "title": "Apartment",
      "description": "Interior shot of an apartment closet showing white wire shelving along the walls for organized storage.",
      "link": "",
      "alt_text": "Empty walk-in closet with white wire shelves on beige walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-8b32-734a-b38c-f1b07d31a002.webp"
    },
    {
      "id": "custom_802667d3-8fd3-4231-b62a-002dd3dcd538",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-6273-7288-a837-fe086fe65afe.webp",
      "image_media": {
        "alt_text": "Table set for dinner with wine glasses and plates in a modern lounge.",
        "public_id": "019d20ba-6273-7288-a837-fe086fe65afe",
        "storage_key": "property/6767906449167042/019d20ba-6273-7288-a837-fe086fe65afe.webp",
        "width": 1254,
        "height": 836
      },
      "title": "Lifestyle",
      "description": "A stylish resident dining lounge with a table set for a meal, featuring wine glasses, plates, and contemporary lighting.",
      "link": "",
      "alt_text": "Table set for dinner with wine glasses and plates in a modern lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-e463-7767-9aba-9f36dd28abd2.webp"
    },
    {
      "id": "custom_8be3e86a-51ee-48fe-8e50-83475a87f287",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-6613-7698-8118-d45bca19a09d.webp",
      "image_media": {
        "alt_text": "Nighttime view of a blue-lit cable-stayed bridge over calm water",
        "public_id": "019d20ba-6613-7698-8118-d45bca19a09d",
        "storage_key": "property/6767906449167042/019d20ba-6613-7698-8118-d45bca19a09d.webp",
        "width": 1998,
        "height": 749
      },
      "title": "Lifestyle",
      "description": "Exterior night photo of a blue-lit cable-stayed bridge over a calm river, with reflections.",
      "link": "",
      "alt_text": "Nighttime view of a blue-lit cable-stayed bridge over calm water",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-e632-7752-8761-841eea9ebbfb.webp"
    },
    {
      "id": "custom_a64b30ed-350c-42bb-b7df-f9554fe18dc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-67c3-757d-97c2-d971ec7f1258.webp",
      "image_media": {
        "alt_text": "Exterior view of Magnolia multifamily building with patio and string lights.",
        "public_id": "019d20ba-67c3-757d-97c2-d971ec7f1258",
        "storage_key": "property/6767906449167042/019d20ba-67c3-757d-97c2-d971ec7f1258.webp",
        "width": 1258,
        "height": 833
      },
      "title": "Lifestyle",
      "description": "Exterior view of Magnolia apartment community with gated entry, patio seating, and landscaped courtyard.",
      "link": "",
      "alt_text": "Exterior view of Magnolia multifamily building with patio and string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-e469-74f9-b4a2-1bf29fa6add8.webp"
    },
    {
      "id": "custom_242e6661-45d1-4f98-8418-f2c1e030d702",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-6efa-7764-80ff-c2fffb2a024e.webp",
      "image_media": {
        "alt_text": "Close-up of a person holding a white travel mug beside a bicycle.",
        "public_id": "019d20ba-6efa-7764-80ff-c2fffb2a024e",
        "storage_key": "property/6767906449167042/019d20ba-6efa-7764-80ff-c2fffb2a024e.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "Lifestyle photo of a person with a bicycle, conveying active living at the apartment community.",
      "link": "",
      "alt_text": "Close-up of a person holding a white travel mug beside a bicycle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-f09b-76f9-96f3-dc10345cd3b4.webp"
    },
    {
      "id": "custom_189cfd22-48c4-41ac-a27e-abacb0528c44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-7230-75f4-9e2c-6b3a6df7e024.webp",
      "image_media": {
        "alt_text": "Children with backpacks boarding a yellow school bus.",
        "public_id": "019d20ba-7230-75f4-9e2c-6b3a6df7e024",
        "storage_key": "property/6767906449167042/019d20ba-7230-75f4-9e2c-6b3a6df7e024.webp",
        "width": 788,
        "height": 663
      },
      "title": "Lifestyle",
      "description": "Children with backpacks line up to board a yellow school bus, capturing a typical school-day moment.",
      "link": "",
      "alt_text": "Children with backpacks boarding a yellow school bus.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-f26e-7466-9c59-feadcc18e4a6.webp"
    },
    {
      "id": "custom_a9605652-9224-4303-ad6c-6eccfbfbc353",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d20ba-7b7c-7039-ad04-c855330a61cf.webp",
      "image_media": {
        "alt_text": "Outdoor shopping plaza with brick storefronts, planters, and pedestrians.",
        "public_id": "019d20ba-7b7c-7039-ad04-c855330a61cf",
        "storage_key": "property/6767906449167042/019d20ba-7b7c-7039-ad04-c855330a61cf.webp",
        "width": 788,
        "height": 469
      },
      "title": "Lifestyle",
      "description": "An outdoor lifestyle center at the apartment community featuring shops, seating, and landscaping along brick storefronts.",
      "link": "",
      "alt_text": "Outdoor shopping plaza with brick storefronts, planters, and pedestrians.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167042/019cfb51-f606-7339-924e-142eb002cc0b.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a7746605-4672-4627-8b9c-1c93e9b91742",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "4017 Jack Kultgen Fwy, Waco, TX 76706, USA",
      "poi_short_description": "Relaxed, colorful eatery serving chicken tenders and sandwiches with varying spice levels, plus fries and sides.",
      "poi_long_description": "People say this chicken restaurant serves delicious chicken sandwiches, sliders, and tenders. They also highlight the flavorful spices, crispy and juicy chicken, and the combination of pickles and sauce.\n\nOther reviews mention the wait can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-5bf7-749c-9220-35572ab42160.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-5bf7-749c-9220-35572ab42160",
        "storage_key": "property/6767906449167042/019cfb52-5bf7-749c-9220-35572ab42160.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://restaurants.daveshotchicken.com/tx/waco/best-hot-chicken-sandwich-on-jack-kultgen-fwy/?utm_campaign=google_maps&utm_medium=organic&utm_source=google&utm_content=website&utm_keyword=1100",
      "poi_directions_map_url": "https://maps.google.com/?cid=3412861589969195137&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "31.5095836",
      "poi_longitude": "-97.1434222",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 254-301-0198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3189-7727-bf63-3b4c8a5945ff",
        "storage_key": "property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx4yhCgKBT4YRgVCwsYjrXC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_61c7b446-28ff-41a6-a19a-c3c1c9d1f36f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Chuy's",
      "poi_type": "Restaurants",
      "poi_address": "5501 Legend Lake Pkwy, Waco, TX 76712, USA",
      "poi_short_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_long_description": "People say this Tex-Mex restaurant serves flavorful fajitas, cheese enchiladas, and Chuy-Changas. They also highlight the fun atmosphere, affordable prices, and great margaritas.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-5be2-712a-b980-49dd1782da12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-5be2-712a-b980-49dd1782da12",
        "storage_key": "property/6767906449167042/019cfb52-5be2-712a-b980-49dd1782da12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chuys.com/locations/tx/waco/waco-tx/6016?cmpid=br:chy_ag:ie_ch:loc_ca:CHYGMB_sn:gmb_gt:waco-tx-6016_pl:locurl_rd:1015",
      "poi_directions_map_url": "https://maps.google.com/?cid=16889027093936889792&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuys",
      "poi_latitude": "31.495272",
      "poi_longitude": "-97.159275",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 254-420-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3189-7727-bf63-3b4c8a5945ff",
        "storage_key": "property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM9gvrD-BT4YRwF8O-KjgYeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_424a1d66-618e-493b-8c2b-6f5053fd3fb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Topgolf Waco",
      "poi_type": "Restaurants",
      "poi_address": "2301 Creekview Dr., Waco, TX 76711, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun and exciting experience with excellent service from the staff and management. They also highlight the delicious food and drinks, as well as the engaging game options like Sonic and Angry Birds.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-5c88-70f3-ac58-6cd1752027db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-5c88-70f3-ac58-6cd1752027db",
        "storage_key": "property/6767906449167042/019cfb52-5c88-70f3-ac58-6cd1752027db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://topgolf.com/us/waco/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13729390873098416531&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-waco",
      "poi_latitude": "31.5036082",
      "poi_longitude": "-97.1506348",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-379-9210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3189-7727-bf63-3b4c8a5945ff",
        "storage_key": "property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzQhfrRiBT4YRk3GF9UGYiL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1a745b1c-5117-419d-8715-9e435980c5f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Main Event Waco",
      "poi_type": "Restaurants",
      "poi_address": "2420 Creekview Dr., Waco, TX 76711, USA",
      "poi_short_description": "Family-friendly entertainment center offering bowling, laser tag and arcade games.",
      "poi_long_description": "People say this restaurant offers a wide variety of fun activities, including bowling, laser tag, and arcade games, as well as delicious pizza and wings. They highlight the lively and welcoming atmosphere, and the friendly and helpful staff. They also like the well-maintained facilities and the quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-5c24-77ef-87d4-2a95ebc44774.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-5c24-77ef-87d4-2a95ebc44774",
        "storage_key": "property/6767906449167042/019cfb52-5c24-77ef-87d4-2a95ebc44774.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mainevent.com/waco/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12340595568029274912&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-waco",
      "poi_latitude": "31.5055942",
      "poi_longitude": "-97.1473834",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 254-256-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3189-7727-bf63-3b4c8a5945ff",
        "storage_key": "property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDXz3vrSBT4YRIBMlLUmaQqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a825ba92-883a-4be8-bcd9-eac9eb4804dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Bojangles",
      "poi_type": "Restaurants",
      "poi_address": "12016 I-35, Lorena, TX 76655, USA",
      "poi_short_description": "Brisk fast-food option for fried chicken and biscuit sandwiches, plus breakfast tacos.",
      "poi_long_description": "People say this restaurant serves fresh chicken tenders, biscuits, and fries. They also highlight the friendly service and quick drive-thru.\n\nOther reviews mention the biscuits can be hard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-5c69-75bf-a9c2-7fa01aca1a17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-5c69-75bf-a9c2-7fa01aca1a17",
        "storage_key": "property/6767906449167042/019cfb52-5c69-75bf-a9c2-7fa01aca1a17.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://locations.bojangles.com/tx/lorena/12016-interstate-35.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16933162427212613054&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bojangles",
      "poi_latitude": "31.394689",
      "poi_longitude": "-97.20774",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-322-9228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3189-7727-bf63-3b4c8a5945ff",
        "storage_key": "property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8G5-219RYYRvsX_BYOt_uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9227764d-3f01-43ba-aea2-6ec1c30e2e56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Richland Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 W Waco Dr, Waco, TX 76710, USA",
      "poi_short_description": "Low-key indoor mall with a familiar range of chain retailers & department stores, plus a food court.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a thriving atmosphere. They also highlight the convenient layout, easy parking, and friendly staff.\n\nOther reviews mention the mall can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-5c3f-7539-99dc-af42c8ef6b58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-5c3f-7539-99dc-af42c8ef6b58",
        "storage_key": "property/6767906449167042/019cfb52-5c3f-7539-99dc-af42c8ef6b58.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.richlandmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4753002464235028715&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "richland-mall",
      "poi_latitude": "31.5164049",
      "poi_longitude": "-97.188648",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-776-6631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-315c-7435-a5d4-95e0bdaa9537",
        "storage_key": "property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2ZnYRqiGT4YR6wBJCY8O9kE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c09a8e33-fe41-48cf-a7e5-9fb4d5b179c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "H-E-B plus!",
      "poi_type": "Shopping & Retail",
      "poi_address": "9100 Woodway Dr, Woodway, TX 76712, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, and HEB brand products, often exceeding national brands in quality. They highlight the competitive prices, efficient checkout lines, and convenient hours. They also like the friendly and helpful staff, and the clean, well-stocked store with a beautiful, inviting atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-10ba-7259-8602-8fc105bf0416.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-10ba-7259-8602-8fc105bf0416",
        "storage_key": "property/6767906449167042/019cfb52-10ba-7259-8602-8fc105bf0416.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/woodway/woodway-h-e-b-plus--583?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=12448309962667135100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-e-b-plus",
      "poi_latitude": "31.4951475",
      "poi_longitude": "-97.2218233",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-751-0239",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314b-71a8-9c1a-41ea2b7270b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314b-71a8-9c1a-41ea2b7270b3",
        "storage_key": "property/6767906449167042/019cfb52-314b-71a8-9c1a-41ea2b7270b3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzrjY4qGT4YRfBC7AvVHwaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a5753071-5a36-4132-a30c-c4b3e0b9a153",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "5605 W Waco Dr, Waco, TX 76710, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products and supplies. They also highlight the friendly staff and the military discount.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-5c05-728e-b2a5-3596929e2639.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-5c05-728e-b2a5-3596929e2639",
        "storage_key": "property/6767906449167042/019cfb52-5c05-728e-b2a5-3596929e2639.webp",
        "width": 1280,
        "height": 560
      },
      "poi_business_url": "https://www.homedepot.com/l/Waco/TX/Waco/76710/6532?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13574066467796885504&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "31.5183601",
      "poi_longitude": "-97.1839128",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-772-8177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-315c-7435-a5d4-95e0bdaa9537",
        "storage_key": "property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJc-k5wGET4YRACCTsojFYLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_464d276a-2824-44e5-ae00-a0c3d4068b32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "201 N New Rd, Waco, TX 76710, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products, including appliances, tools, and building materials, with many praising its selection and organization. They also highlight the helpful and friendly staff, and appreciate the clean and well-maintained environment.\n\nSome reviews mention the return policy can be restrictive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-5c25-719a-85ac-d1a0f06d69a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-5c25-719a-85ac-d1a0f06d69a6",
        "storage_key": "property/6767906449167042/019cfb52-5c25-719a-85ac-d1a0f06d69a6.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-Waco/0129?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-129-_-na-_-0-_-0&y_source=1_MTE4Mjk0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=554208923653939692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "31.525613",
      "poi_longitude": "-97.169521",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 254-776-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-315c-7435-a5d4-95e0bdaa9537",
        "storage_key": "property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhcPAQfuDT4YR7KG-aRTysAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_b35a91ce-357c-4699-b6c5-0fd871426a54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "2604 W Loop 340, Waco, TX 76711, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-5c25-719a-85ac-cc44f0d567be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-5c25-719a-85ac-cc44f0d567be",
        "storage_key": "property/6767906449167042/019cfb52-5c25-719a-85ac-cc44f0d567be.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18181548089954678295&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "31.4978416",
      "poi_longitude": "-97.1558566",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-662-2940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-315c-7435-a5d4-95e0bdaa9537",
        "storage_key": "property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJC6WGcmqBT4YRFzZuaKjVUfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_3d46e87c-28da-43b9-88dd-01ecccb249e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Hewitt Public Library",
      "poi_type": "Education",
      "poi_address": "200 Patriot Ct, Hewitt, TX 76643, USA",
      "poi_short_description": "Public library with a large selection, kids' options, and activities, plus a highly praised interior.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-5dd1-721a-ae2c-27126e8596c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-5dd1-721a-ae2c-27126e8596c7",
        "storage_key": "property/6767906449167042/019cfb52-5dd1-721a-ae2c-27126e8596c7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cityofhewitt.com/32/Library",
      "poi_directions_map_url": "https://maps.google.com/?cid=8881197190975822813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hewitt-public-library",
      "poi_latitude": "31.4435509",
      "poi_longitude": "-97.2082402",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 254-666-2442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3157-772f-aa82-52786f99255a",
        "storage_key": "property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQSOO-SGHT4YR3ZtPZMpZQHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_98157ba0-3e68-425c-89e7-c8544a186246",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Panther Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Hewitt, TX 76643, USA",
      "poi_short_description": "Stadium hosting high school football and band competitions, plus other sporting events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6040-739c-a020-d67d3d4872d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-6040-739c-a020-d67d3d4872d0",
        "storage_key": "property/6767906449167042/019cfb52-6040-739c-a020-d67d3d4872d0.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.midwayisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=597293818787365563&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "panther-stadium",
      "poi_latitude": "31.4803098",
      "poi_longitude": "-97.202348",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-761-5680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6c93-724f-a0c6-6d8322bc7534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-6c93-724f-a0c6-6d8322bc7534",
        "storage_key": "property/6767906449167042/019cfb52-6c93-724f-a0c6-6d8322bc7534.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKWrSn-eGT4YRu4JbR5ADSgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_278c14ed-08da-4278-af8c-6f62307c8aed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Waco ISD Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1401 S New Rd, Waco, TX 76711, USA",
      "poi_short_description": "Clean outdoor venue offering concessions and plenty of parking.",
      "poi_long_description": "People say this stadium offers a spacious, open-air entertainment arena and a great field for football. They highlight the friendly staff and plenty of parking. They also like the professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6023-70ca-8c36-b7c00fd8d41f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-6023-70ca-8c36-b7c00fd8d41f",
        "storage_key": "property/6767906449167042/019cfb52-6023-70ca-8c36-b7c00fd8d41f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wacoisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15536238726280488529&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "waco-isd-stadium",
      "poi_latitude": "31.5081383",
      "poi_longitude": "-97.1598713",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-745-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6c93-724f-a0c6-6d8322bc7534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-6c93-724f-a0c6-6d8322bc7534",
        "storage_key": "property/6767906449167042/019cfb52-6c93-724f-a0c6-6d8322bc7534.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ80UJF2BT4YRUaadmc7Om9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e15adb02-6f82-4952-86a8-ca9c10bc7c0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "5701 W Waco Dr, Waco, TX 76710, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, dodgeball, and a Sky Rider. They also highlight the clean environment, friendly staff, and attentive service.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6040-739c-a020-d148bd9189f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-6040-739c-a020-d148bd9189f7",
        "storage_key": "property/6767906449167042/019cfb52-6040-739c-a020-d148bd9189f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/texas-waco/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=14018805896551914086&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "31.5173095",
      "poi_longitude": "-97.1843299",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 254-845-8004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbQBRHaqGT4YRZtogJ7DNjMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_48156b0f-7de5-4786-85fb-e7b4dbdb4b25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Rocket Field",
      "poi_type": "Entertainment",
      "poi_address": "Robinson, TX 76706, USA",
      "poi_short_description": "Facility primarily for football games featuring parking and clean restrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6005-703c-88b1-7fd28de12b04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-6005-703c-88b1-7fd28de12b04",
        "storage_key": "property/6767906449167042/019cfb52-6005-703c-88b1-7fd28de12b04.webp",
        "width": 1170,
        "height": 658
      },
      "poi_business_url": "https://texasbob.com/stadium/stadium.php?id=154",
      "poi_directions_map_url": "https://maps.google.com/?cid=16305345843491567565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rocket-field",
      "poi_latitude": "31.4631942",
      "poi_longitude": "-97.1232708",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6c93-724f-a0c6-6d8322bc7534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-6c93-724f-a0c6-6d8322bc7534",
        "storage_key": "property/6767906449167042/019cfb52-6c93-724f-a0c6-6d8322bc7534.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh8l2-niBT4YRzfc0vac5SOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0a3a6a0a-2d78-4515-900e-958040a3a217",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Rice Field",
      "poi_type": "Entertainment",
      "poi_address": "8500 Mars Dr, Waco, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-618c-70df-acfc-8ef4fdfdeb4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-618c-70df-acfc-8ef4fdfdeb4c",
        "storage_key": "property/6767906449167042/019cfb52-618c-70df-acfc-8ef4fdfdeb4c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7528190653330043656&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rice-field",
      "poi_latitude": "31.4816888",
      "poi_longitude": "-97.2051809",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6c93-724f-a0c6-6d8322bc7534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-6c93-724f-a0c6-6d8322bc7534",
        "storage_key": "property/6767906449167042/019cfb52-6c93-724f-a0c6-6d8322bc7534.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBfL6dOaGT4YRCDMnXYOBeWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_8c197abc-ecec-46cb-8ee1-81c6ced2ea55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "300 N Valley Mills Dr, Waco, TX 76710, USA",
      "poi_short_description": "Chain of clean, down-to-earth gyms featuring cardio equipment, locker rooms and tanning machines.",
      "poi_long_description": "People say this gym offers a wide variety of workout equipment and supplements. They highlight the clean and well-maintained facilities, and the welcoming and less intimidating atmosphere. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6176-72f3-8b5c-90cdd089101a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-6176-72f3-8b5c-90cdd089101a",
        "storage_key": "property/6767906449167042/019cfb52-6176-72f3-8b5c-90cdd089101a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/waco-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4080706577757134135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.52663759999999",
      "poi_longitude": "-97.166908",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 254-224-5203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMYZg6-SDT4YRN13QDwOVoTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_eac865af-b4fb-4be9-8ef7-4b5fa70b6de1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Texas Dynasty Cheer & Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "800 Schroeder Dr Suite C, Waco, TX 76710, USA",
      "poi_short_description": "Spacious venue for gymnastics and cheerleading, featuring classes and parties.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6154-727a-9a82-74b93f7a6bbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-6154-727a-9a82-74b93f7a6bbf",
        "storage_key": "property/6767906449167042/019cfb52-6154-727a-9a82-74b93f7a6bbf.webp",
        "width": 768,
        "height": 1024
      },
      "poi_business_url": "http://txdynasty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10922492512142983377&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-dynasty-cheer--gymnastics",
      "poi_latitude": "31.51086889999999",
      "poi_longitude": "-97.173836",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 254-776-6248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3157-772f-aa82-52786f99255a",
        "storage_key": "property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoxbCvqqGT4YR0YAl6BF9lJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e2f9cb23-3e6a-476e-988a-e2695f299bd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Waco Animal Emergency Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 Jack Kultgen Fwy, Waco, TX 76706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-619f-706b-9dd4-d2200e308989.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-619f-706b-9dd4-d2200e308989",
        "storage_key": "property/6767906449167042/019cfb52-619f-706b-9dd4-d2200e308989.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://wacoanimalemergencyclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742041022524351834&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "waco-animal-emergency-clinic",
      "poi_latitude": "31.5114638",
      "poi_longitude": "-97.1418971",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 254-752-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKWX0LXqBT4YRWuUQeEpBcWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_249b348e-552c-4f32-9d01-25cd94f4ba8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Gold's Gym Waco",
      "poi_type": "Health and Wellness",
      "poi_address": "250 N New Rd, Waco, TX 76710, USA",
      "poi_short_description": "Chain fitness center offering weight machines, cardio equipment, and personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-619f-706b-9dd4-d6b5977346e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-619f-706b-9dd4-d6b5977346e1",
        "storage_key": "property/6767906449167042/019cfb52-619f-706b-9dd4-d6b5977346e1.webp",
        "width": 1024,
        "height": 597
      },
      "poi_business_url": "https://www.goldsgym.com/wacotx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10121885265704463436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym-waco",
      "poi_latitude": "31.5237946",
      "poi_longitude": "-97.172795",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-399-9393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy9RClPyDT4YRTCyTZwUpeIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f2aa5330-a35a-41e1-bca6-0a6d09cb2b06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "South Bosque Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "14000 Woodway Dr, Woodway, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-62c8-7571-ae69-412b6c390c17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-62c8-7571-ae69-412b6c390c17",
        "storage_key": "property/6767906449167042/019cfb52-62c8-7571-ae69-412b6c390c17.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://southbosquevet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10304119130262063319&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-bosque-veterinary-clinic",
      "poi_latitude": "31.4858006",
      "poi_longitude": "-97.2501019",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 254-776-7738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL4mIADyGT4YR18iTYsGV_44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_8f4fb060-1a73-4825-ace4-90744b57c8cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "P&J Nails & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "8810 Woodway Dr Ste 308-309, Waco, TX 76712, USA",
      "poi_short_description": "Fresh, clean, bright salon featuring a host of nail services, as well as massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-64a1-7730-aa40-6f3e08b2fed9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-64a1-7730-aa40-6f3e08b2fed9",
        "storage_key": "property/6767906449167042/019cfb52-64a1-7730-aa40-6f3e08b2fed9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pjnailsspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13770156859534457257&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pj-nails--spa",
      "poi_latitude": "31.4966677",
      "poi_longitude": "-97.218016",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-546-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dPGZMyHT4YRqbn10bRsGb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_51b594bc-2476-47bf-930f-436b010517c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "SOLAR NAILS",
      "poi_type": "Health and Wellness",
      "poi_address": "514 N New Rd, Waco, TX 76710, USA",
      "poi_short_description": "Friendly, clean nail parlor providing manicures and pedicures, plus solar, dip and gel nails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-64e2-741b-98a3-854b0ec9d759.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-64e2-741b-98a3-854b0ec9d759",
        "storage_key": "property/6767906449167042/019cfb52-64e2-741b-98a3-854b0ec9d759.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://nailapp4u.as.me/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3290486307482252215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "solar-nails",
      "poi_latitude": "31.5272044",
      "poi_longitude": "-97.173159",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-741-0304",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbUffM_qDT4YRtzPE59wnqi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_24c1d58f-b1a5-40ef-8289-92ed46ee062b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Champions Salon & Barber",
      "poi_type": "Health and Wellness",
      "poi_address": "6706 Woodway Dr, Woodway, TX 76712, USA",
      "poi_short_description": "Relaxed barber shop offering haircuts, hair coloring, shaves, beer and beard treatments for men.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-64ec-72d5-9451-be3dd2f0cdb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-64ec-72d5-9451-be3dd2f0cdb1",
        "storage_key": "property/6767906449167042/019cfb52-64ec-72d5-9451-be3dd2f0cdb1.webp",
        "width": 1242,
        "height": 699
      },
      "poi_business_url": "https://championssalonandbarber.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14678263090437169950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "champions-salon--barber",
      "poi_latitude": "31.5090823",
      "poi_longitude": "-97.1929389",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-855-9744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjasfRaSGT4YRHiM8EYOqs8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_3f4344ee-9a43-46e6-bc9d-5865952a7608",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Cottonwood Creek Veterinary Hospital - Woodway",
      "poi_type": "Health and Wellness",
      "poi_address": "22014 Woodway Dr, Woodway, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6515-7412-92e3-c1c4fd6a8d7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-6515-7412-92e3-c1c4fd6a8d7c",
        "storage_key": "property/6767906449167042/019cfb52-6515-7412-92e3-c1c4fd6a8d7c.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.ccvethosp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9725733287381250668&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cottonwood-creek-veterinary-hospital---woodway",
      "poi_latitude": "31.4845183",
      "poi_longitude": "-97.2598062",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-772-7295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJezvi5XGHT4YRbDKNTuW--IY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_24f97aa4-22bd-4e19-a46b-5db1a59e2f50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Sharkey's Cuts For Kids",
      "poi_type": "Health and Wellness",
      "poi_address": "2440 W Loop 340 Ste A8, Waco, TX 76711, USA",
      "poi_short_description": "Fun salon, specializing in kids' haircuts for boys and girls, where children can sit in cars.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6525-7709-935f-f2cd51f74e9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-6525-7709-935f-f2cd51f74e9c",
        "storage_key": "property/6767906449167042/019cfb52-6525-7709-935f-f2cd51f74e9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kidshaircutswaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15891680027354367707&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sharkeys-cuts-for-kids",
      "poi_latitude": "31.4982278",
      "poi_longitude": "-97.1581879",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-265-6989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe_vY5UCBT4YR24aggsmWitw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_2d34fd79-7850-42b7-8cd9-3f8828d757f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Baylor Scott & White Medical Center - Hillcrest",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Hillcrest Medical Blvd, Waco, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-1c5f-72bd-a347-922f45945760.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-1c5f-72bd-a347-922f45945760",
        "storage_key": "property/6767906449167042/019cfb52-1c5f-72bd-a347-922f45945760.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/hillcrest?utm_source=pg-google&utm_medium=organic&utm_campaign=29985-3814861",
      "poi_directions_map_url": "https://maps.google.com/?cid=8216934832998146127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "baylor-scott--white-medical-center---hillcrest",
      "poi_latitude": "31.4890068",
      "poi_longitude": "-97.1576836",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 254-202-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-362c-772c-8667-08cbecbcb63b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-362c-772c-8667-08cbecbcb63b",
        "storage_key": "property/6767906449167042/019cfb52-362c-772c-8667-08cbecbcb63b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyaGo4T2BT4YRT2BjB7JqCHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3b5f6957-af58-488c-b203-d68452dfec72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Ascension Providence Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6901 Medical Pkwy, Waco, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-2a1d-724a-a8f9-0acf145d2881.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-2a1d-724a-a8f9-0acf145d2881",
        "storage_key": "property/6767906449167042/019cfb52-2a1d-724a-a8f9-0acf145d2881.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/texas/txwac/waco-ascension-providence-hospital?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6492679134749646913&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-providence-hospital",
      "poi_latitude": "31.5136822",
      "poi_longitude": "-97.1991448",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-751-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-362c-772c-8667-08cbecbcb63b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-362c-772c-8667-08cbecbcb63b",
        "storage_key": "property/6767906449167042/019cfb52-362c-772c-8667-08cbecbcb63b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRliM6CGT4YRQeBX-0WhGlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_36693565-0906-40a0-80db-c8edd3d6a014",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Cottonwood Creek Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5200 Bagby Ave, Waco, TX 76711, USA",
      "poi_short_description": "Casual public course with a pro shop stocking golf gear & accessories, plus club fittings & repairs.",
      "poi_long_description": "People say this golf course is beautiful and forgiving. They also highlight the course is well-maintained and in excellent condition.\n\nOther reviews mention the staff can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6682-73bd-b50b-4039c6b34825.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-6682-73bd-b50b-4039c6b34825",
        "storage_key": "property/6767906449167042/019cfb52-6682-73bd-b50b-4039c6b34825.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.waco-texas.com/cottonwood",
      "poi_directions_map_url": "https://maps.google.com/?cid=2026844058063726421&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cottonwood-creek-golf-course",
      "poi_latitude": "31.5064126",
      "poi_longitude": "-97.1617916",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 254-745-6009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6c96-70ef-bd3e-16d93d7a82ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-6c96-70ef-bd3e-16d93d7a82ee",
        "storage_key": "property/6767906449167042/019cfb52-6c96-70ef-bd3e-16d93d7a82ee.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJk7hY4kKBT4YRVef_n-7LIBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_9e5b5ff3-a998-4e7b-b929-edd284649d13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Woodway Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1625 Estates Dr, Woodway, TX 76712, USA",
      "poi_short_description": "City park featuring a disc-golf course, 2 pavilions with BBQ grills, a playground & lake views.",
      "poi_long_description": "People say this city park offers scenic hiking trails through the woods and along the lake shore, and is a great place to enjoy a sunset. They highlight the spacious and peaceful vibe, suitable for relaxation and family time. They also like the well-maintained trails and the easy access to the lake. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-66ae-76cb-bba0-0e9bacaf429b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-66ae-76cb-bba0-0e9bacaf429b",
        "storage_key": "property/6767906449167042/019cfb52-66ae-76cb-bba0-0e9bacaf429b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverwoodway.com/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2535205004088397821&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodway-park",
      "poi_latitude": "31.5222564",
      "poi_longitude": "-97.2338532",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 254-772-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3631-752e-b1c0-22a70ecf5c8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3631-752e-b1c0-22a70ecf5c8e",
        "storage_key": "property/6767906449167042/019cfb52-3631-752e-b1c0-22a70ecf5c8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu45KvHuGT4YR_U975YTbLiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1e453cb2-72bb-438a-82ae-d49d6ce88de9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Whitehall Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Whitehall Park, 7600 Fresno Rd, Woodway, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds for children of all ages, tennis courts, a dog park, and a walking track. They highlight the clean restrooms, water fountains for people and dogs, and shaded areas with a free book nook. They also like the ample space for picnics and the availability of sidewalk chalk.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-679a-728c-83ec-f379df51ffc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-679a-728c-83ec-f379df51ffc7",
        "storage_key": "property/6767906449167042/019cfb52-679a-728c-83ec-f379df51ffc7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://discoverwoodway.com/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=605218144821514294&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whitehall-park",
      "poi_latitude": "31.5083728",
      "poi_longitude": "-97.2090007",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 254-772-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3631-752e-b1c0-22a70ecf5c8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3631-752e-b1c0-22a70ecf5c8e",
        "storage_key": "property/6767906449167042/019cfb52-3631-752e-b1c0-22a70ecf5c8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____A5uGT4YRNhC1NbIqZgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_95f44802-6f46-4832-860d-90fd9ef1033e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Carleen Bright Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9001 Bosque Blvd b, Woodway, TX 76712, USA",
      "poi_short_description": "This 16-acre preserve features 8 acres of landscaped botanical gardens, trails & an event gazebo.",
      "poi_long_description": "People say this arboretum offers beautiful gardens, walking trails, and a playground with a splash pad. They highlight the peaceful and relaxing atmosphere, and the family-friendly environment. They also like the well-maintained grounds and the abundance of butterflies and birds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-2356-7429-9de2-1533ea86aa8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-2356-7429-9de2-1533ea86aa8d",
        "storage_key": "property/6767906449167042/019cfb52-2356-7429-9de2-1533ea86aa8d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://discoverwoodway.com/arboretum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17033175476687828014&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carleen-bright-arboretum",
      "poi_latitude": "31.509655",
      "poi_longitude": "-97.230204",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-399-9204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3631-752e-b1c0-22a70ecf5c8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3631-752e-b1c0-22a70ecf5c8e",
        "storage_key": "property/6767906449167042/019cfb52-3631-752e-b1c0-22a70ecf5c8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmd1xfHmGT4YRLnTftNn-Yew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_4bc37398-0ce6-4a85-9a90-4de58cf061ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "The Hewitt Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "801 S Hewitt Dr, Hewitt, TX 76643, USA",
      "poi_short_description": "32-acre park with a fitness trail, disc-golf course, soccer fields, picnic pavilions & playgrounds.",
      "poi_long_description": "People say this city park offers a variety of recreational activities, including volleyball, soccer, and disc golf, as well as a paved running/walking trail and a small creek for exploring. They highlight the clean and well-maintained facilities, including restrooms and a pavilion with picnic tables, and the relaxing atmosphere. They also like the ample parking and the availability of a reservable pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-21d0-773f-9357-5d1485c3232b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-21d0-773f-9357-5d1485c3232b",
        "storage_key": "property/6767906449167042/019cfb52-21d0-773f-9357-5d1485c3232b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofhewitt.com/facilities/facility/details/City-of-Hewitt-Parks-2",
      "poi_directions_map_url": "https://maps.google.com/?cid=1573394582175150990&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-hewitt-park",
      "poi_latitude": "31.4525624",
      "poi_longitude": "-97.204979",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 254-666-2447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3631-752e-b1c0-22a70ecf5c8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3631-752e-b1c0-22a70ecf5c8e",
        "storage_key": "property/6767906449167042/019cfb52-3631-752e-b1c0-22a70ecf5c8e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzEtgBOHT4YRjvMSSgnS1RU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_949982a4-8f10-463c-9da0-93b2fab05f73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "SimpleBills",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Ritchie Rd Level, Waco, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-68d5-76bc-9cfd-3bdd1b8b5720.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-68d5-76bc-9cfd-3bdd1b8b5720",
        "storage_key": "property/6767906449167042/019cfb52-68d5-76bc-9cfd-3bdd1b8b5720.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://simplebills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16944888496387797706&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "simplebills",
      "poi_latitude": "31.4875414",
      "poi_longitude": "-97.2392911",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-230-0199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2AZWFCCT4YRyjLMQU9WKOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cb0db565-d899-41cd-994e-69fefe08b89b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Spring Valley Elementary School",
      "poi_type": "Education",
      "poi_address": "610 Spring Valley Rd, Hewitt, TX 76643, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-13ea-735d-b6b2-980d17d1838e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-13ea-735d-b6b2-980d17d1838e",
        "storage_key": "property/6767906449167042/019cfb52-13ea-735d-b6b2-980d17d1838e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.midwayisd.org/schools/sve",
      "poi_directions_map_url": "https://maps.google.com/?cid=521950885504671369&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spring-valley-elementary-school",
      "poi_latitude": "31.4418115",
      "poi_longitude": "-97.1980985",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 254-761-5710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3157-772f-aa82-52786f99255a",
        "storage_key": "property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF07fWUGHT4YRid60oJBXPgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_530ab4d1-40bf-45fd-b6d0-13f190e91617",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Park Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "700 Ritchie Rd, Hewitt, TX 76643, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.midwayisd.org/schools/phe",
      "poi_directions_map_url": "https://maps.google.com/?cid=14349738326321064720&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "park-hill-elementary-school",
      "poi_latitude": "31.4486903",
      "poi_longitude": "-97.2135083",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 254-761-5770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3157-772f-aa82-52786f99255a",
        "storage_key": "property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj67OA1uHT4YREOssyPqCJMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_beba9d6e-ed5e-4ccb-abd5-6e36cf6114c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Castleman Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "755 S Hewitt Dr, Hewitt, TX 76643, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-12d1-75eb-87ee-35d076bf9676.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-12d1-75eb-87ee-35d076bf9676",
        "storage_key": "property/6767906449167042/019cfb52-12d1-75eb-87ee-35d076bf9676.webp",
        "width": 1280,
        "height": 533
      },
      "poi_business_url": "https://www.midwayisd.org/schools/cce",
      "poi_directions_map_url": "https://maps.google.com/?cid=11527975764977917413&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "castleman-creek-elementary-school",
      "poi_latitude": "31.4552394",
      "poi_longitude": "-97.20376",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 254-761-5755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3157-772f-aa82-52786f99255a",
        "storage_key": "property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmZfOOPOGT4YR5R3SYuGY-58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0f813de0-5076-411f-9ca8-5358f0366e25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Midway Middle School",
      "poi_type": "Education",
      "poi_address": "800 N Hewitt Dr, Hewitt, TX 76643, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-13be-7612-af37-652c3aec369e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-13be-7612-af37-652c3aec369e",
        "storage_key": "property/6767906449167042/019cfb52-13be-7612-af37-652c3aec369e.webp",
        "width": 1280,
        "height": 787
      },
      "poi_business_url": "https://www.midwayisd.org/schools/mms",
      "poi_directions_map_url": "https://maps.google.com/?cid=8404076084458446421&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "midway-middle-school",
      "poi_latitude": "31.4785338",
      "poi_longitude": "-97.2043323",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-761-5680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3157-772f-aa82-52786f99255a",
        "storage_key": "property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm6gTJeiGT4YRVV6AD6xGoXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_eaf3e76b-7544-425e-b769-26328ba7c63e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Midway High School",
      "poi_type": "Education",
      "poi_address": "8200 Mars Dr, Waco, TX 76712, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-13bf-739d-bd60-f1b5b252b2ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-13bf-739d-bd60-f1b5b252b2ef",
        "storage_key": "property/6767906449167042/019cfb52-13bf-739d-bd60-f1b5b252b2ef.webp",
        "width": 1280,
        "height": 689
      },
      "poi_business_url": "https://www.midwayisd.org/schools/mhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=13456395274140648670&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "midway-high-school",
      "poi_latitude": "31.4840095",
      "poi_longitude": "-97.1991769",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-761-5650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3157-772f-aa82-52786f99255a",
        "storage_key": "property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_29EOWKGT4YR3gRm8DS4vro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_999f627c-fb69-41f9-bf8f-4af327b3301e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Baylor University",
      "poi_type": "Education",
      "poi_address": "1311 S 5th St, Waco, TX 76706, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-2de1-7368-afdc-3a7ea07cbc99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2de1-7368-afdc-3a7ea07cbc99",
        "storage_key": "property/6767906449167042/019d7917-2de1-7368-afdc-3a7ea07cbc99.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.baylor.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7163770527817390045&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "baylor-university",
      "poi_latitude": "31.5500848",
      "poi_longitude": "-97.11354",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-229-5678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3157-772f-aa82-52786f99255a",
        "storage_key": "property/6767906449167042/019cfb52-3157-772f-aa82-52786f99255a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkebHSWqCT4YR3df3-lbTamM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_33e9f0f3-0cb7-489d-be7a-ce2f35af51fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Marco's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "100 B Ritchie Rd, Hewitt, TX 76643, USA",
      "poi_short_description": "Counter-serve chain serving up a menu of specialty or custom pizzas for takeout or delivery.",
      "poi_long_description": "People say this pizza restaurant serves yummy pizzas and salads. They highlight the quick and easy pickup service, and the well-sliced pizzas. They also like the friendly staff and prompt delivery service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-2d5c-7238-8ff4-1fb236a4fab4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2d5c-7238-8ff4-1fb236a4fab4",
        "storage_key": "property/6767906449167042/019d7917-2d5c-7238-8ff4-1fb236a4fab4.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.marcos.com/our-locations/restaurants/TX/Hewitt/marcos-pizza-b-ritchie-rd-hewitt-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=4653680183306149018&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "marco-s-pizza",
      "poi_latitude": "31.4463592",
      "poi_longitude": "-97.20511",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 254-777-8778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3189-7727-bf63-3b4c8a5945ff",
        "storage_key": "property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfYIR28-HT4YRmtw8cHgxlUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_a4673c0b-5b15-455d-8ace-df07cfadb2b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Mexicano Grille",
      "poi_type": "Restaurants",
      "poi_address": "259 N Hewitt Dr, Hewitt, TX 76643, USA",
      "poi_short_description": "Casual Mexican restaurant with a kids' menu and a popular Taco Tuesday, plus breakfast.",
      "poi_long_description": "People say this Mexican restaurant serves fresh and delicious food, including enchiladas, tacos, and quesadillas. They also highlight the reasonable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-04ad-740e-8db3-8b7cce05bfb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-04ad-740e-8db3-8b7cce05bfb6",
        "storage_key": "property/6767906449167042/019cfb52-04ad-740e-8db3-8b7cce05bfb6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mexicanogrillehewitt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8965401772506637109&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mexicano-grille",
      "poi_latitude": "31.4680071",
      "poi_longitude": "-97.1993907",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 254-262-8101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3189-7727-bf63-3b4c8a5945ff",
        "storage_key": "property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCxnJxyGHT4YRNWPqTmmBa3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_c18365af-6b12-477c-8960-447552b8fb0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "J-Petal & Poke Hewitt",
      "poi_type": "Restaurants",
      "poi_address": "875 S Hewitt Dr Suite 13, Hewitt, TX 76643, USA",
      "poi_short_description": "Trendy spot serving poke bowls, sushi burritos, plus Japanese crepes and rolled ice cream.",
      "poi_long_description": "People say this restaurant serves fresh and delicious poke bowls, poki-ritos, and crepes. They highlight the great flavor combinations, healthy options, and customizable bowls. They also like the vibrant and youthful, yet calm and relaxing atmosphere, and the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-444f-758e-9b9e-d6e251bd8b9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-444f-758e-9b9e-d6e251bd8b9c",
        "storage_key": "property/6767906449167042/019d7917-444f-758e-9b9e-d6e251bd8b9c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://jpetaltx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4608982175837317175&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "j-petal-poke-hewitt",
      "poi_latitude": "31.44973569999999",
      "poi_longitude": "-97.2040202",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 254-300-5911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3189-7727-bf63-3b4c8a5945ff",
        "storage_key": "property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg1j0_3KHT4YRN-jjlt5k9j8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3fa772f0-03ba-45de-bf0a-94d18b6d45e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Billy Bob's Burgers Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "899 S Hewitt Dr, Hewitt, TX 76643, USA",
      "poi_short_description": "Casual bar known for burgers and American dishes, plus beer and wine.",
      "poi_long_description": "People say this restaurant serves great burgers, Philly cheesesteaks, and onion rings. They also highlight the friendly and attentive service, and the chill atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-3347-76de-9028-ba1aee05402f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3347-76de-9028-ba1aee05402f",
        "storage_key": "property/6767906449167042/019d7917-3347-76de-9028-ba1aee05402f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://billybobsburgerstx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2886570386902504132&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "billy-bob-s-burgers-bar-grill",
      "poi_latitude": "31.4492321",
      "poi_longitude": "-97.2036537",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 254-224-6332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3189-7727-bf63-3b4c8a5945ff",
        "storage_key": "property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG3KrJ2GHT4YRxFJ8InkoDyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e52a3789-fa15-4f3f-a318-e2aee0397336",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "George’s Restaurant Bar & Catering #2",
      "poi_type": "Restaurants",
      "poi_address": "1201 Hewitt Dr #100, Waco, TX 76712, USA",
      "poi_short_description": "Old-school operation offering hearty American fare & drinks in a TV-equipped space.",
      "poi_long_description": "People say this restaurant serves delicious chicken fried steak, nachos, and catfish. They also highlight the reasonable prices, fun atmosphere, and friendly service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-3477-75ba-b0f0-b1b9a46cebb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3477-75ba-b0f0-b1b9a46cebb8",
        "storage_key": "property/6767906449167042/019d7917-3477-75ba-b0f0-b1b9a46cebb8.webp",
        "width": 950,
        "height": 633
      },
      "poi_business_url": "https://georgesrestaurant.com/georges-hewitt/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16800031789085559799&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "george-s-restaurant-bar-catering-2",
      "poi_latitude": "31.486952",
      "poi_longitude": "-97.2128087",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-420-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3189-7727-bf63-3b4c8a5945ff",
        "storage_key": "property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ28vfGGT4YR9wu32-azJek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_057977d9-0a19-4500-bb4c-57c42f86e8ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Bush's Chicken",
      "poi_type": "Restaurants",
      "poi_address": "1301 Hewitt Dr, Waco, TX 76712, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken, plus catfish, hushpuppies & desserts.",
      "poi_long_description": "People say this restaurant serves great chicken and sweet tea. They also highlight the fresh food and speedy service.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-3d2e-7079-9b96-b070e035599f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3d2e-7079-9b96-b070e035599f",
        "storage_key": "property/6767906449167042/019d7917-3d2e-7079-9b96-b070e035599f.webp",
        "width": 1280,
        "height": 806
      },
      "poi_business_url": "http://www.bushschicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16625657300415515299&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bush-s-chicken",
      "poi_latitude": "31.4859938",
      "poi_longitude": "-97.2112739",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-666-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3189-7727-bf63-3b4c8a5945ff",
        "storage_key": "property/6767906449167042/019cfb52-3189-7727-bf63-3b4c8a5945ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNSa1J-6GT4YRo4qlbDozuuY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8c55cc32-e663-4269-b830-ccb4377bbbc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Central Texas Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 W Loop 340, Waco, TX 76711, USA",
      "poi_short_description": "Shopping center featuring specialty shops and eateries, plus parking.",
      "poi_long_description": "People say this shopping center offers a wide selection of stores, including clothing, outdoor goods, and restaurants. They highlight the convenient location near hotels and Baylor University, and the ample parking. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-43a4-715c-b2f9-79c90b40c85a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-43a4-715c-b2f9-79c90b40c85a",
        "storage_key": "property/6767906449167042/019d7917-43a4-715c-b2f9-79c90b40c85a.webp",
        "width": 1280,
        "height": 337
      },
      "poi_business_url": "https://amzn.to/3HKyLbO",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038514282824941598&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "central-texas-marketplace",
      "poi_latitude": "31.4974622",
      "poi_longitude": "-97.1568051",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-265-5255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-315c-7435-a5d4-95e0bdaa9537",
        "storage_key": "property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJm8_xx2qBT4YRHkB3zI33T4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c68c33c7-d60e-4800-b47e-3d6ea5cb38a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Cottonwood Creek Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 Creekview Dr., Waco, TX 76711, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13244250817067523843&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cottonwood-creek-market",
      "poi_latitude": "31.5041224",
      "poi_longitude": "-97.1482996",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-315c-7435-a5d4-95e0bdaa9537",
        "storage_key": "property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3YpFYbSBT4YRA598c_IHzbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f1f50591-2026-4860-8f7c-5278c715567a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Woodway Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "123 Topeka Dr Suit G, Woodway, TX 76712, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-45f2-7176-a9d1-1494daad45d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-45f2-7176-a9d1-1494daad45d6",
        "storage_key": "property/6767906449167042/019d7917-45f2-7176-a9d1-1494daad45d6.webp",
        "width": 1280,
        "height": 801
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6980890420110957626&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "woodway-plaza",
      "poi_latitude": "31.506378",
      "poi_longitude": "-97.2025301",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-315c-7435-a5d4-95e0bdaa9537",
        "storage_key": "property/6767906449167042/019cfb52-315c-7435-a5d4-95e0bdaa9537.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBww6kLiHT4YROhykytka4WA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1dbab1d0-72d1-48c5-a786-fd1b949df844",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Midway ISD Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "800 N Hewitt Dr, Hewitt, TX 76643, USA",
      "poi_short_description": "Casual performance venue hosting diverse shows, including dance and music, in a large space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-488a-7799-9284-c502427c73e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-488a-7799-9284-c502427c73e7",
        "storage_key": "property/6767906449167042/019d7917-488a-7799-9284-c502427c73e7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.midwayisd.org/finearts",
      "poi_directions_map_url": "https://maps.google.com/?cid=13853483453254270025&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "midway-isd-performing-arts-center",
      "poi_latitude": "31.4788735",
      "poi_longitude": "-97.2040284",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-761-5675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYcTTu-aGT4YRSfz4RM11QcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_709f6cbc-4222-4e9f-a419-4b36236dea1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Whitehall Center - at the Carleen Bright Arboretum",
      "poi_type": "Entertainment",
      "poi_address": "9001 Bosque Blvd, Woodway, TX 76712, USA",
      "poi_short_description": "Event venue and arboretum with trails, a splash pad, and a variety of plants and trees.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-533a-7540-a60d-5381babf4906.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-533a-7540-a60d-5381babf4906",
        "storage_key": "property/6767906449167042/019d7917-533a-7540-a60d-5381babf4906.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3858863224983830780&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whitehall-center-at-the-carleen-bright-arboretum",
      "poi_latitude": "31.509397",
      "poi_longitude": "-97.229738",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 254-399-9212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-zX1nuGT4YR_MD6cahvjTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_af0a57dc-d97e-422e-9a0d-89a2fee2353b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Cameron Park",
      "poi_type": "Entertainment",
      "poi_address": "Cameron Park, Waco, TX 76708, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8382660255820780182&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cameron-park",
      "poi_latitude": "31.5748741",
      "poi_longitude": "-97.1685751",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD7hlSWyDT4YRlpL75BYxVXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e2c97768-b323-48de-b916-32d7e888f402",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Cameron Park Zoo",
      "poi_type": "Entertainment",
      "poi_address": "1701 N 4th St, Waco, TX 76707, USA",
      "poi_short_description": "Verdant, 52-acre zoo featuring numerous wild animals plus a gift shop, cafes & events.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including lions, giraffes, elephants, rhinos, otters, and penguins, with many indoor exhibits and shaded pathways. They highlight the spacious layout, well-maintained enclosures, and family-friendly atmosphere, as well as the worthwhile membership option. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-18a2-71cd-83b6-8167085fc66d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-18a2-71cd-83b6-8167085fc66d",
        "storage_key": "property/6767906449167042/019cfb52-18a2-71cd-83b6-8167085fc66d.webp",
        "width": 960,
        "height": 422
      },
      "poi_business_url": "http://www.cameronparkzoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13803951944348861414&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cameron-park-zoo",
      "poi_latitude": "31.5701472",
      "poi_longitude": "-97.1445667",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 21 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 254-750-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-314c-7169-993a-f77d9d26b97d",
        "storage_key": "property/6767906449167042/019cfb52-314c-7169-993a-f77d9d26b97d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSJ7CQaDT4YR5gN6Kyh9kb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_810dca00-4a87-463b-9512-67fd3a6da98b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "McLane Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1001 S M.L.K. Jr Blvd, Waco, TX 76704, USA",
      "poi_short_description": "Sports stadium featuring clean restrooms, food and drink sold at various outlets, as well as modern amenities, such as tailgating.",
      "poi_long_description": "Fans say this stadium is a great place to watch the Baylor Bears play football, and they appreciate the free water stations, plentiful restrooms, and easy access. They also highlight the friendly and helpful staff, as well as the respectful and hospitable Baylor fans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-5bd4-766f-8590-9e3282ef7425.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5bd4-766f-8590-9e3282ef7425",
        "storage_key": "property/6767906449167042/019d7917-5bd4-766f-8590-9e3282ef7425.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mclanestadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=948108573633282188&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mclane-stadium",
      "poi_latitude": "31.5582127",
      "poi_longitude": "-97.1156424",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-710-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-6c93-724f-a0c6-6d8322bc7534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-6c93-724f-a0c6-6d8322bc7534",
        "storage_key": "property/6767906449167042/019cfb52-6c93-724f-a0c6-6d8322bc7534.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLRpHmF2CT4YRjADqc7lbKA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_d8039100-24cd-4bf6-96ed-066fbf81f1a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "poi_name": "Dr Pepper Museum",
      "poi_type": "Entertainment",
      "poi_address": "300 S 5th St, Waco, TX 76701, USA",
      "poi_short_description": "Nonprofit gallery examining the history & memorabilia of soft drinks in a 1906 bottling plant.",
      "poi_long_description": "People say this museum offers a fun and informative experience with lots of interesting history and exhibits. They also highlight the reasonable price, the free soda, and the opportunity to make your own soda.\n\nOther reviews mention the gift shop can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019d7917-53eb-746a-8821-bf82cac77969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-53eb-746a-8821-bf82cac77969",
        "storage_key": "property/6767906449167042/019d7917-53eb-746a-8821-bf82cac77969.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.drpeppermuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11954819412563611991&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dr-pepper-museum",
      "poi_latitude": "31.5551583",
      "poi_longitude": "-97.1295999",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-757-1024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-3146-754a-b4ca-79e020d0a9bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-3146-754a-b4ca-79e020d0a9bd",
        "storage_key": "property/6767906449167042/019cfb52-3146-754a-b4ca-79e020d0a9bd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOakuHk6CT4YRV1HMl-oM6KU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    }
  ],
  "office_hours": [
    {
      "id": "ec_7acd2f196653e1316023724a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_3f99e266a93016cc2673f129",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_18113065d22cd856a7ab7a90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_98bfe09a7ec8148b29f118e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_ade80d338e80fe6e73c8884b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1d47b4c09250d883d210e08b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_511458f29585ef78049dfee3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "rating": "5",
      "name": "Kaylie Mellinger",
      "text": "Not a resident yet, but my partner and I went for a tour recently because we’re unhappy with our current place. The best experience we’ve had with an apartment complex so far!\nThe lady that helped us was very funny and down to earth, she answered all of our questions about leasing. The grounds and amenities were very clean from what we saw.\nI had a nice interaction with one of the residents while in the office, which just added on to my experience.\nThe first thing my partner said after we left was “why didn’t we move here in the first place?!”\nWhile it may not be the cheapest place in the area, they clearly take care of the complex and I’m willing to pay for that quality!\nVery excited to apply and I hope to become a resident soon!",
      "date": "2025-12-20",
      "title": "false"
    },
    {
      "id": "ec_4a780309dfffdfce899149d1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "rating": "5",
      "name": "Queen Braden",
      "text": "From the first day I walked in and spoke with Courtney, my experience was top notch! She listened and understood what my husband and I needed. She came through with flying colors! The process was seamless. Information and requirements were clearly set from the beginning so there were no surprises! Received our keys a day early, which was super fantastic! We slept beautifully our first night last night here! The community is quiet, my neighbors ate super nice, the police and fire department are right across the street so safety is visible and FELT! WE ABSOLUTELY LOVE IT HERE!!! Wished I could give TEN STARS!!!",
      "date": "2026-01-05",
      "title": "false"
    },
    {
      "id": "ec_9927d79408b175ab7c5be672",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "rating": "5",
      "name": "FireMerk Studios",
      "text": "Absolutely fantastic service. Front office did not hesitate and was extremely helpful in setting up a request with maintenance. By the time I returned back after running errands, the issue was taken care of, without any issues. Amazing.",
      "date": "2025-10-18",
      "title": "false"
    },
    {
      "id": "ec_ac5be870382aa445c4616001",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "rating": "5",
      "name": "jamesa bates",
      "text": "I just moved in and honestly it's a breath of fresh air living at icon . Haven't met any neighbors yet but I can tell they are so sweet and the office staff is incredible the landscaping is off the charts! Your best bet at best living is with Icon at Hewitt!💋",
      "date": "2025-11-19",
      "title": "false"
    },
    {
      "id": "ec_906d9e750b2169985d7006e2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "rating": "5",
      "name": "Cory Vande Berg",
      "text": "I stayed at Icon for 5 months for work.  They work with you for shorter lease times under 6 months, with an added fee, which is really helpful when it's not a permanent residence.  The place was very clean when I arrived, with only one cause of concern, which was quickly addressed.  Everyone at the front desk was very nice and easy to work with.  The other tenants were all very nice people.  I made a lot of friends while I was there.  The pool, grills, and lounge are awesome.  It's in a quiet part of town with a short drive to restaurants and grocery.  I highly recommend Icon at Hewitt to anyone, single, married, or with children.",
      "date": "2025-06-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_868b3604-5379-4afd-ba72-5618147ab49a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb52-e52d-7289-ba02-54d8316c0526.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360-degree view of a modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019cfb52-e52d-7289-ba02-54d8316c0526",
        "storage_key": "property/6767906449167042/019cfb52-e52d-7289-ba02-54d8316c0526.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Icon at Hewitt Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62fe376494cfe83ff1a92593&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-3d70-71b4-845d-88a9d7f1e5d7",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "icon-at-hewitt",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042"
    },
    {
      "lead_collector_id": "019cf79e-3de4-743f-b079-3dfad8cf0833",
      "lead_source": "LANDING_PAGE",
      "name": "icon-at-hewitt",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "icon-at-hewitt-pet-friendly-apartments",
      "search_query": "pet friendly apartments Hewitt TX",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments Hewitt TX",
      "h2_subtitle": "Discover pet friendly living in Hewitt, TX. Enjoy amenities perfect for you and your furry friend at Icon at Hewitt.",
      "page_copy": "Looking for pet friendly apartments in Hewitt, TX? Icon at Hewitt offers more than just a home; it presents a lifestyle that welcomes you and your furry friends. Our gated community embraces pet ownership with spacious courtyards equipped with pet stations, ensuring convenience and cleanliness for all residents. \n\nBeyond our pet-friendly features, you’ll find other amenities like a 24-hour fitness center and an onsite bark park, perfect for keeping both you and your pets active. Icon at Hewitt ensures comfort and peace of mind with garages available for parking and added security. Experience a community that truly values and supports the joy of pet companionship.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Hewitt, TX",
      "seo_description": "Explore the perfect pet friendly apartments in Hewitt, TX, at Icon at Hewitt, featuring amenities like courtyards with pet stations and an onsite bark park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "icon-at-hewitt-apartments-with-pool-mclennan-county",
      "search_query": "apartments with a pool in McLennan County",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in McLennan County",
      "h2_subtitle": "Enjoy modern living at Icon at Hewitt in McLennan County, featuring comfortable apartments and exciting amenities like a community pool.",
      "page_copy": "If you're searching for apartments with a pool in McLennan County, look no further than Icon at Hewitt. Our community offers a vibrant lifestyle with amenities designed for your enjoyment and relaxation. While we pride ourselves on a vast array of features, the planned community pool will be the perfect place for residents to unwind and socialize.\n\nIcon at Hewitt isn’t just about leisure; it also provides practical features such as garages and a 24-hour fitness center to accommodate your busy lifestyle. Our pet-friendly environments include courtyards with pet stations and an onsite bark park, making it a great choice for families and pet owners. Come experience the blend of comfort and fun in one of the most welcoming communities in the county.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in McLennan County",
      "seo_description": "Discover apartments with a pool at Icon at Hewitt in McLennan County, offering vibrant living with premium amenities. Explore our community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "icon-at-hewitt-garages-available-apartments",
      "search_query": "garages available apartments near 76643",
      "category": "Amenity",
      "h1_title": "Garages Available Apartments Near 76643",
      "h2_subtitle": "Enjoy the convenience of garages at Icon at Hewitt, located near the 76643 area. Perfect for your busy lifestyle.",
      "page_copy": "Looking for apartments with garages available near the 76643 area? Icon at Hewitt offers the perfect solution. Situated within a short distance from key locations in Hewitt, TX, our community provides the convenience of garages, ensuring your vehicle is kept safe and secure.\n\nBeyond our practical amenities, Icon at Hewitt also offers a gated community atmosphere with a state-of-the-art 24-hour fitness center and beautiful courtyards complete with pet stations. Our onsite bark park makes it a welcoming place for pet owners as well. Experience the perfect blend of practical and leisure amenities right here in Hewitt.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Garages Available Apartments Near 76643",
      "seo_description": "Find garages available at Icon at Hewitt near the 76643 area. Enjoy secure parking and convenient living with top amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "icon-at-hewitt-fitness-center-apartments",
      "search_query": "apartments with a fitness center in Hewitt",
      "category": "Amenity",
      "h1_title": "Apartments with a Fitness Center in Hewitt",
      "h2_subtitle": "Icon at Hewitt offers modern apartments with a 24-hour fitness center, perfect for residents in Hewitt seeking an active lifestyle.",
      "page_copy": "For those in search of apartments with a fitness center in Hewitt, Icon at Hewitt is the ideal choice. Our state-of-the-art, 24-hour fitness center caters to residents who prioritize their health and fitness, offering the flexibility to work out on their own schedule. \n\nBeyond our fitness amenities, Icon at Hewitt is a gated community that provides additional perks like pet-friendly courtyards with pet stations and an onsite bark park. Residents can also enjoy the convenience of garages available for secure parking. Discover a community that balances lifestyle and comfort perfectly, right here at Icon at Hewitt.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Fitness Center in Hewitt",
      "seo_description": "Explore Icon at Hewitt's apartments with a 24-hour fitness center. Perfect for those in Hewitt seeking convenient, active living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "icon-at-hewitt-dog-park-apartments-mclennan-county",
      "search_query": "dog park apartments in McLennan County",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in McLennan County",
      "h2_subtitle": "Discover pet-friendly living at Icon at Hewitt, featuring spacious apartments and an onsite dog park in McLennan County.",
      "page_copy": "Searching for dog park apartments in McLennan County? Icon at Hewitt is your ideal pet-friendly solution. Our community features an onsite bark park, offering a safe and fun environment for your furry friends to play and socialize.\n\nIn addition to our amenities aimed at pets, residents also enjoy a variety of features that cater to different lifestyles. These include a gated community for added security, garages available for parking, and a 24-hour fitness center for workout enthusiasts. Experience a living space that appreciates pets as much as their owners here at Icon at Hewitt.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in McLennan County",
      "seo_description": "Icon at Hewitt offers dog park apartments in McLennan County, combining pet-friendly features with modern amenities. Join our community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "icon-at-hewitt-two-bedroom-apartments",
      "search_query": "two bedroom apartments hewitt tx",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Hewitt, TX",
      "h2_subtitle": "Explore spacious two bedroom apartments at Icon at Hewitt. Enjoy comfortable living in the heart of Hewitt, TX with modern amenities.",
      "page_copy": "Experience the perfect blend of comfort and convenience with our two bedroom apartments in Hewitt, TX at Icon at Hewitt. Designed with spacious layouts and modern finishes, each apartment provides a welcoming environment perfect for a variety of lifestyles. \n\nOur community enhances your living experience with amenities such as a 24-hour fitness center, a gated entrance for added security, and pet-friendly courtyards featuring pet stations. With garages available for all residents, parking has never been easier. Discover what elevates apartment living at Icon at Hewitt, where style meets practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Hewitt, TX",
      "seo_description": "Discover two bedroom apartments in Hewitt, TX at Icon at Hewitt, complete with modern amenities and convenient features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "icon-at-hewitt-one-bedroom-apartments",
      "search_query": "one bedroom apartments mclennan county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in McLennan County",
      "h2_subtitle": "Find the perfect one bedroom apartments at Icon at Hewitt, ideally located in McLennan County, offering comfort and style.",
      "page_copy": "Icon at Hewitt in McLennan County offers elegantly designed one bedroom apartments that cater to your needs. Enjoy the spacious layouts and modern finishes aimed at providing a cozy and functional living space, perfect for singles or couples.\n\nOur community boasts a variety of amenities, including a 24-hour fitness center, gated access, and garages available for ease of parking. For pet lovers, the onsite bark park and pet-friendly courtyards make it an ideal living environment. Experience the perfect balance of convenience and comfort in your new home at Icon at Hewitt.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in McLennan County",
      "seo_description": "Explore one bedroom apartments in McLennan County at Icon at Hewitt, offering modern living spaces and comprehensive amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "icon-at-hewitt-near-hillcrest-medical-center",
      "search_query": "apartments near Baylor Scott & White Medical Center Hillcrest Hewitt",
      "category": "Hospital",
      "h1_title": "Apartments near Baylor Scott & White Hillcrest",
      "h2_subtitle": "Located near Baylor Scott & White Medical Center Hillcrest, Icon at Hewitt offers convenient living with modern amenities.",
      "page_copy": "If you're seeking apartments near Baylor Scott & White Medical Center Hillcrest, Icon at Hewitt is the perfect choice. Our community is ideally located in Hewitt, providing quick access to the medical center, making it an excellent option for healthcare professionals and patients seeking nearby accommodations.\n\nEnjoy our range of top-notch amenities, including a 24-hour fitness center, gated community, and available garages. For pet owners, our onsite bark park and pet-friendly courtyards add an extra layer of convenience and enjoyment. Experience refined living with the ease of proximity to one of the leading healthcare centers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments near Baylor Scott & White Hillcrest",
      "seo_description": "Find Icon at Hewitt apartments near Baylor Scott & White Medical Center Hillcrest, offering comfort and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "icon-at-hewitt-near-ascension-providence-hospital",
      "search_query": "apartments close to Ascension Providence Hospital McLennan County",
      "category": "Hospital",
      "h1_title": "Apartments Near Ascension Providence Hospital",
      "h2_subtitle": "Icon at Hewitt, located in McLennan County, offers apartments close to Ascension Providence Hospital with modern conveniences and amenities.",
      "page_copy": "Looking for comfortable and convenient living near Ascension Providence Hospital in McLennan County? Icon at Hewitt provides the perfect solution with our apartment homes, just a short distance from the hospital. This makes our community an excellent choice for healthcare professionals or anyone wanting proximity to medical facilities.\n\nEnjoy living in a gated community equipped with a 24-hour fitness center, pet-friendly courtyards with pet stations, and available garages. With amenities designed to enhance your lifestyle, Icon at Hewitt provides not only a place to live but a vibrant community in a prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ascension Providence Hospital",
      "seo_description": "Discover Icon at Hewitt, offering apartments near Ascension Providence Hospital in McLennan County with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "icon-at-hewitt-near-woodway-park",
      "search_query": "apartments near Woodway Park Hewitt TX",
      "category": "Park",
      "h1_title": "Apartments Near Woodway Park, Hewitt TX",
      "h2_subtitle": "Live close to nature at Icon at Hewitt, located near Woodway Park in Hewitt, TX, offering a perfect blend of comfort and convenience.",
      "page_copy": "Icon at Hewitt is an ideal choice for those seeking apartments near Woodway Park in Hewitt, TX. Our community's convenient location offers quick access to this beautiful outdoor space, perfect for nature enthusiasts and families looking to enjoy scenic walks and recreational activities.\n\nResidents at Icon at Hewitt enjoy a range of modern amenities, including a 24-hour fitness center, gated community access, and pet-friendly courtyards. Whether you're relaxing at home or exploring nearby Woodway Park, our apartments provide the perfect home base for your lifestyle in Hewitt.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Woodway Park, Hewitt TX",
      "seo_description": "Explore Icon at Hewitt, offering comfortable apartments near Woodway Park in Hewitt, TX, with easy access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "icon-at-hewitt-close-to-whitehall-park",
      "search_query": "Icon at Hewitt close to Whitehall Park",
      "category": "Park",
      "h1_title": "Icon at Hewitt Near Whitehall Park",
      "h2_subtitle": "Discover Icon at Hewitt, conveniently close to Whitehall Park, offering a serene living atmosphere with modern comforts in Hewitt, TX.",
      "page_copy": "Situated close to Whitehall Park, Icon at Hewitt offers residents the perfect balance of tranquility and convenience. Our community's prime location ensures you can enjoy the lush landscapes and recreational facilities of Whitehall Park just minutes from your doorstep.\n\nIcon at Hewitt provides a range of modern features, including a 24-hour fitness center, onsite bark park, and pet-friendly courtyards. Whether you're unwinding at home or taking a leisurely stroll through Whitehall Park, our community offers the ideal setting for a comfortable and active lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Icon at Hewitt Near Whitehall Park",
      "seo_description": "Live at Icon at Hewitt, close to Whitehall Park, featuring serene surroundings and modern amenities in Hewitt, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "apartments-near-carleen-bright-arboretum",
      "search_query": "Carleen Bright Arboretum apartments McLennan County",
      "category": "Park",
      "h1_title": "Apartments Near Carleen Bright Arboretum",
      "h2_subtitle": "Discover life at Icon at Hewitt, offering apartments in McLennan County close to Carleen Bright Arboretum with a range of modern amenities.",
      "page_copy": "Experience the natural beauty of Carleen Bright Arboretum while enjoying modern living at Icon at Hewitt in McLennan County. Our apartments are located conveniently near this arboretum, known for its picturesque gardens and serene walking trails. Whether you're a nature lover or simply seeking a peaceful retreat, our community puts you close to this local gem.\n\nAt Icon at Hewitt, residents enjoy features such as a gated community, 24-hour fitness center, and pet-friendly courtyards. With the arboretum nearby, you have the ideal combination of outdoor recreational opportunities and indoor comforts right at your fingertips.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Carleen Bright Arboretum",
      "seo_description": "Icon at Hewitt offers apartments in McLennan County near Carleen Bright Arboretum, combining nature access with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167042",
      "source": "generator",
      "page_item_url": "hewitt-park-nearby-apartments-76643",
      "search_query": "The Hewitt Park nearby apartments 76643",
      "category": "Park",
      "h1_title": "Apartments Near The Hewitt Park, 76643",
      "h2_subtitle": "Enjoy the convenience of living at Icon at Hewitt, featuring nearby apartments to The Hewitt Park in the 76643 area.",
      "page_copy": "Icon at Hewitt offers the ideal location for those seeking apartments conveniently near The Hewitt Park in the 76643 area. Surrounded by beautiful green spaces, our community provides easy access to recreational activities and leisurely weekend picnics.\n\nOur residents benefit from amenities such as a 24-hour fitness center, gated community access, and pet-friendly courtyards. With The Hewitt Park just a stone’s throw away, you can enjoy outdoor adventures, all while indulging in the modern comforts of home at Icon at Hewitt.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
      "featured_image_media": {
        "alt_text": "The Icon apartment building exterior with brick facade, manicured landscaping, and exterior signage.",
        "public_id": "019cfb51-746b-75f9-9307-95a8b029cb4a",
        "storage_key": "property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
        "width": 3072,
        "height": 2460
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near The Hewitt Park, 76643",
      "seo_description": "Live at Icon at Hewitt, offering nearby apartments to The Hewitt Park in the 76643 area with easy access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5181"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-SGQXJJKTB2"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151101"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-icon-at-hewitt/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TPBXNXWR"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167042/019d1bd8-6ae2-711d-9008-e20688e65e4e.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "f96f3966-9fa5-4548-a0d6-416ad0f305d7"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-766-3957"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6504af79bac1ac6f4cc76a58"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjE1aW5rL2xVaWUwS0dQMUNtQVp2Q0E9PSIsInZhbHVlIjoiOUtWTUhuZXhQTjB6bXRDSnMwak92dz09IiwibWFjIjoiOTY5OTI3MTViNzMzYjBjYmI2YzE1ZjI4ODM2YmZhYjcxYzExZWJkNzQyM2Y5YTRiNWM4MWFlNDI3ZTk5NDg0NyJ9"
    }
  ],
  "custom_qb_id": "5181",
  "custom_ga4_id": "G-SGQXJJKTB2",
  "custom_repli_id": "10041151101",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-icon-at-hewitt/register/",
  "custom_google_gtm_id": "GTM-TPBXNXWR",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167042/019d1bd8-6ae2-711d-9008-e20688e65e4e.pdf",
  "custom_rentgrata_property_id": "f96f3966-9fa5-4548-a0d6-416ad0f305d7",
  "custom_ppc_tracking_phone_number": "833-766-3957",
  "custom_residentboost_apartment_id": "6504af79bac1ac6f4cc76a58",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjE1aW5rL2xVaWUwS0dQMUNtQVp2Q0E9PSIsInZhbHVlIjoiOUtWTUhuZXhQTjB6bXRDSnMwak92dz09IiwibWFjIjoiOTY5OTI3MTViNzMzYjBjYmI2YzE1ZjI4ODM2YmZhYjcxYzExZWJkNzQyM2Y5YTRiNWM4MWFlNDI3ZTk5NDg0NyJ9"
};

export const generatedAt = '2026-08-27T21:33:08.054Z';
